import { Component, ElementRef, Renderer2, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { DateInputCustomFormatPlaceholder, DateTimePickerComponent } from '@progress/kendo-angular-dateinputs';
import { ComboBoxComponent } from '@progress/kendo-angular-dropdowns';
import { NumericTextBoxComponent } from '@progress/kendo-angular-inputs';
import { BehaviorSubject, Observable } from 'rxjs';
//import { formComponentMapOptions } from '~/front-models/form-component-map';
import { PurchaseOrderDetailForReceive } from '~/front-models/purchaseOrderGrid';
import { ReceiveTransaction } from '~/front-models/transactionGrid';
import { MultiSiteAwareComponent } from '~/infrastructure/multi-site-aware.component';
import { DataWithPagingMetadata } from '~/infrastructure/paging';
import { GridFieldSummary } from '~/models/modules/gridField';
import { StockItemSummary } from '~/models/modules/item';
import { AccountsService } from '~/services/administration.ts/accounts';
import { AccountsDropdownComponent } from '~/shared/components/accounts-dropdown/accounts-dropdown.component';
import { PrintReceiptsService } from '~/services/administration.ts/print-receipts';
import { ReportsService } from '~/services/modules/reports/reports';
import { BarcodeGeneratorsService } from '~/services/modules/stocks/barcode-generators';
import { GridFieldsService } from '~/services/modules/stocks/gridField';
import { StockItemsService } from '~/services/modules/stocks/items';
import { LocationsService } from '~/services/modules/stocks/locations';
import { PurchaseOrdersService } from '~/services/modules/stocks/purchase-orders';
import { ReceiveTransactionsService } from '~/services/modules/stocks/receive-transactions';
import { VendorsService } from '~/services/modules/stocks/vendors';
import { ThemeManagerService } from '~/services/theme-manager';
import { GridLayoutManagerService } from '~/shared/components/grid/layout/grid-layout-manager';
import { LayoutManagerService } from '~/shared/components/layout/layout-manager';
import { LayoutComponent } from '~/shared/components/layout/layout.component';
import { ReportViewerPopupComponent } from '../../../../shared/components/viewer/popup.component';
import { PageState } from '~/shared/enums/stock-files.enum';
import { POPreferencesService } from '~/services/administration.ts/po-preferences';
import { SysReceivesService } from '~/services/administration.ts/sysReceive';
import { UserSummary } from '~/models/administration/user';
import { SecurityService } from '~/services/security.service';
import { GridFieldTextSummary } from '~/models/modules/GridFieldText';
import { GridFieldAuthorization } from '~/models/administration/securityLevel';
import { FormatService } from '~/services/administration.ts/format';
import { TransactionDateEditingService } from '~/services/modules/stocks/administration/transaction-date-editing';
import { SharedService } from '~/services/sharedService';
import { QuantityFormatsService } from '~/services/administration.ts/quantity-formats';
import { FileInfo, FileState, SelectEvent, UploadComponent } from '@progress/kendo-angular-upload';
import { SalesOrderFile } from '~/models/modules/SalesOrderFile';
import { FilesService } from '~/services/modules/stocks/files';
import { GDataService } from '~/services/GDataService';
import { fileSources } from '~/shared/enums/fileSources';
import { FileSelectedStream } from '~/models/modules/file';
import { allowedFileTypes } from '~/shared/enums/allowedFileTypes';
import { ItemsTypes, Pages } from '~/shared/enums/itemsTypes';
import { InventoriesService } from '~/services/modules/stocks/inventories';
import { IssueTransactionsService } from '~/services/modules/stocks/issue-transaction';
import { Router } from '@angular/router';
import { SitesEnum } from '~/shared/enums/sites.enum';
import { SOToPOPreferencesService } from '~/services/administration.ts/so-to-po-preferences';
import { SiteLisitng } from '~/models/administration/site';
import { MultiSiteService } from '~/services/modules/common/multi-site.service';
import { PageNames } from '~/models/pageNames';

@Component({
    selector: 'app-stock-receive',
    templateUrl: './receive.html',
    styleUrls: ['./receive.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class StockReceiveComponent extends MultiSiteAwareComponent {
  page: string = 'transaction-receive';
  title: string = 'Receive';
  showTextBox = false;

  _showDocumentsGrid: boolean = false;
  _selectedDocumentsKeys: number[] = [];
  _selectedDocuments: any[] = [];
  _fileSource: fileSources;
  _uploadedStream: FileSelectedStream[] = [];
  _selectedExistingFiles: FileSelectedStream[] = [];
  _allowedFileTypes: allowedFileTypes[] = [allowedFileTypes.excel, allowedFileTypes.pdf, allowedFileTypes.word];
  _selectedAccounts: any[] = [];
  _uploaderSelectMessage: string = 'Upload file..';
  _selectedObjectDocuments: any[] = [];

  autoCorrect = true;
  _currentUser: UserSummary;
  _hasFieldControlLicense: boolean = false;
  _theme: string;
  _form: FormGroup;
  _barcodePopupForm: FormGroup;
  _barcodePopupFormFields: any = [];
  _invalidForm: boolean;
  _model: any;
  _fileStream: any;
  _file: File;
  _selectFile: boolean = false;
  _hasRequired: boolean = false;
  _costFormat: string;
  quantityFormat: string;
  uploadSaveUrl = 'saveUrl'; // should represent an actual API endpoint
  uploadRemoveUrl = 'removeUrl'; // should represent an actual API endpoint
  _selectedAccount = new FormControl();
  _stockItemFilesDocs: SalesOrderFile[] = [];

  _selectedpofromdropdownlist: any[] = [];
  _deletedPOItems: any[] = [];
  _sortingSelected = new FormControl('old');
  _quickScan = new FormControl();
  _defaultQuantity = new FormControl();
  _defaultDate = new FormControl();
  _autoCodeGeneration = new FormControl();
  _inventoryCode = new FormControl();
  _quantity = new FormControl();
  _expirationDate = new FormControl();

  _locations: any[];
  _locationsFiltered: any[];
  _purchaseOrders: any[];
  _purchaseOrdersFiltered: any[];
  _vendors: any[];
  _vendorsFiltered: any[];
  _selectedStockItem = new FormControl();
  _TransactionNotes = new FormControl();
  _items: any[];
  _itemsFiltered: any[];
  _inventoryGridData: ReceiveTransaction[] = [];
  _itemType: 'standard' | 'batch' | 'serial' | 'serial-with-quantity' | 'non-inventory';
  _itemtypeId: ItemsTypes;
  _barcodePopupActive: boolean;
  _minDate: Date = new Date(1901, 1, 1);
  _printReceipt = new FormControl(false);
  _showStocksGrid: boolean = false;
  _showLocationsGrid: boolean = false;
  _showVendorsGrid: boolean = false;
  _selectedStocks: StockItemSummary[] = [];
  _selectedLocations: any[] = [];
  _selectedVendors: any[] = [];
  _stockItemsGridColumns: GridFieldSummary[];
  _locationsGridColumns: GridFieldSummary[];
  _vendorsGridColumns: GridFieldSummary[];
  _settingsPrintReceipt: any;
  transactionId: number;
  showReports: boolean = false;
  _selectedCallback = (args: { dataItem: any }) => args.dataItem;
  receiveReports: any;
  _poPreference: any;
  _showVendorStockItemOnPOAndRece: boolean = false;
  _addNewStockSettingEnabled: boolean;
  _defaultLocationSettingEnabled: boolean = false;
  _receiveBatchItemsAllowDuplicateInvEnabled: boolean;
  _receiveUDField1Show: boolean;
  _receiveUDField2Show: boolean;
  _receiveUDField3Show: boolean;
  _receiveUDHeaderField1Show: boolean;
  _receiveUDHeaderField2Show: boolean;
  _receiveUDHeaderField3Show: boolean;
  _receiveUDFieldDate1Show: boolean;
  _receiveUDFieldDate2Show: boolean;
  _receiveUDFieldDate3Show: boolean;
  /* Fields' Names */
  _receiveUDField1Name: string;
  _receiveUDField2Name: string;
  _receiveUDField3Name: string;
  _receiveUDHeaderField1Name: string;
  _receiveUDHeaderField2Name: string;
  _receiveUDHeaderField3Name: string;
  _receiveUDFieldDate1Name: string;
  _receiveUDFieldDate2Name: string;
  _receiveUDFieldDate3Name: string;
  _itemFilter: string;
  _pageState: PageState;
  _selectedLabelObjectCode: any;
  _selectedLabelText: string;
  _editFormActive: boolean;
  _isRenameFormValue: boolean = false;
  _isRenameCustomFormValue: boolean = false;
  _isRenameLabel: boolean = false;
  _isMandatory: boolean = false;
  _isCustomfieldsFormValue: boolean = false;
  _isAddTabFormValue: boolean = false;
  _selectedAccountIds: any[] = [];
  _language: string = 'en';
  _page: string = 'receiveHistory';
  _gridFieldText: GridFieldTextSummary[];
  _gridFieldAuth: GridFieldAuthorization[];
  _locationAuth: GridFieldAuthorization;
  _purchaseOrderAuth: GridFieldAuthorization;
  _hasPurchaseOrderLicense: boolean = false;
  _vendorAuth: GridFieldAuthorization;
  _isTransaction: boolean = false;
  _onlyRequired: boolean = false;
  _moveInventories: any[] = [];
  _selectedInventoryKeys: number[] = [];
  _datePickerFormat: string;
  _dateFormatlabel: DateInputCustomFormatPlaceholder = { year: 'YYYY', month: 'MM', day: 'DD', hour: '', minute: '', second: '' };

  _dateEnabled: boolean;

  userinputqty: any = 0;

  isFromSo: boolean = false;
  isSoToPoEnable: boolean = false;
  stockSalesOrderId: number = 0;

  _dialogComponentName: string;
  _isDialiog: boolean = false;
  _dialogModel: any;
  digitNumber: number;

  _barcodemodel: any = {
    BarcodeValues: [],
    LabelSizeID: 0,
    Row: 0,
    Column: 0,
    LabelPresetId: 0,
    LabelSize: {},
    numberOfCopy: 1,
    tableName: 'StockReceive'
  };

  windowMode = true;
  _printLabelsEnabled: boolean = false;
  _printLabelsSettingsEnabled: boolean = false;
  _previewWindow: boolean = false;
  _printLabel = new FormControl();
  _isOneLineItem: boolean = true;
  comboBoxpagingationParams = {
    currentItem: '0',
    totalbyPage: 20,
    search: '',
    page: 1
  };
  prevoiusValue: string;
  beginScroll: boolean;
  clearTimeout: any;
  _invalidavailableqty: boolean;

  @ViewChild('kendo_combo_items') drop: any;
  isOpened: boolean = false;
  timeOut: any;
  isLoading: boolean = false;
  _additionalErrors: any[] = [];

  GridColumsbehavior: BehaviorSubject<GridFieldSummary[]>;


  //#region New StockItem Combobox Fields
  _itemsNew: any[];
  _itemsFilteredNew: any[];
  _allStockItemsCount: number = 0;
  _stockItemComboBoxPagingParams = {
    currentItem: '0',
    totalbyPage: 20,
    search: '',
    page: 1
  };
  _stockItemComboScroll: boolean = false;
  _stockItemDDSearch: string = null;
  //#endregion
  //Sites Drop
  _siteAuth: GridFieldAuthorization;
  _selectSitesGridActive: boolean;
  _sitesPageName: string = 'sites';
  _sitesGridFields: GridFieldSummary[];
  _selectedsite: number;
  _sitesDD = new FormControl();
  // #region Multi-Site
  _isMultiSite: boolean = false;
  _isMultiSiteSelected: boolean = false;
  // #endregion

  @ViewChild('kendo_combo_accounts') kendoComboAccounts: AccountsDropdownComponent;
  @ViewChild('kendo_combo_sites') kendoComboSites: ComboBoxComponent;
  @ViewChild('kendo_combo_vendors') kendoComboVendors: ComboBoxComponent;
  @ViewChild('kendo_combo_locations') kendoComboLocations: ComboBoxComponent;
  @ViewChild('kendo_combo_items') kendoComboItems: ComboBoxComponent;
  @ViewChild('quantity_input') quantityInput: NumericTextBoxComponent;
  @ViewChild('expiration_date') expirationDateInput: DateTimePickerComponent;
  @ViewChild('inventory_id') inventoryIdInput: ElementRef;
  @ViewChild('kendo_combo_Receipt_Report') selectReceiptReport: ComboBoxComponent;
  @ViewChild('kendo_uploader_wrapper') uploadWrapper: ElementRef;
  @ViewChild('kendo_uploader') upload: UploadComponent;

  constructor(private _fb: FormBuilder,
    private sitesService: MultiSiteService,
    private _themeManager: ThemeManagerService,
    private _accountsService: AccountsService,
    private _vendorsService: VendorsService,
    private _locationsService: LocationsService,
    private _purchaseOrdersService: PurchaseOrdersService,
    private _receiveTransactionsService: ReceiveTransactionsService,
    private _stockItemsService: StockItemsService,
    private _barcodeGeneratorsService: BarcodeGeneratorsService,
    private _layoutComponent: LayoutComponent,
    private _layoutManager: LayoutManagerService,
    private _gridLayoutManagerService: GridLayoutManagerService,
    private _gridFields: GridFieldsService,
    private _printReceiptsService: PrintReceiptsService,
    private _reportService: ReportsService,
    private _poPreferencesService: POPreferencesService,
    private _sysReceivesService: SysReceivesService,
    private _securityService: SecurityService,
    private _formatService: FormatService,
    private _issueTransactionsService: IssueTransactionsService,
    private _TransactionDateEditting: TransactionDateEditingService,
    private quantityFormatsService: QuantityFormatsService,
    private _sharedService: SharedService,
    private _filesService: FilesService,
    private _dataService: GDataService,
    private _renderer2: Renderer2,
    private _inventoriesService: InventoriesService,
    private router: Router,
    private _sOToPOPreferencesService: SOToPOPreferencesService,
    private _gridLayoutManagerServicelocation: GridLayoutManagerService) {
    super();
    this.GridColumsbehavior = this._gridLayoutManagerServicelocation.subscribeToColumnsChanges2()
    this._inventoryGridData = [];
    this.getBatchStockItems();

    this.LoadData();
    this._themeManager.themeChange.subscribe((data) => {
      this._theme = data;
    });

    this._layoutManager.okCloseClicked.subscribe((data) => {
      // if (data) {
      //     if (this._form.get('site').value == null) {
      //         setTimeout(() => {
      //             this.kendoComboAccounts.toggle();
      //             this.kendoComboAccounts.focus();
      //         });
      //     } else {
      //         setTimeout(() => {
      //             this.kendoComboItems.toggle();
      //             this.kendoComboItems.focus();
      //         });
      //     }
      // }
    });

    this._layoutManager.formChanged.subscribe((x) => {
      if (x === 'vendors') {
        this._loadVendorsDD();
      }

      if (x === 'locations') {
        if (this._form.get('site').value && !this._defaultLocationSettingEnabled) {
          this._loadLocationsDD(this._form.get('site').value ?? '');
        }
        else {
          setTimeout(() => {
            if (this.kendoComboVendors != undefined) {
              this.kendoComboVendors.toggle();
              this.kendoComboVendors.focus();
            }
          });
        }
      }

      if (x === 'purchaseOrders') {
        //if (this._form.get('site').value) {
        this._loadPurchaseOrdersDD();
        //}
      }
    });

    this._gridFields.getGridFieldsByPage('vendors').subscribe((data: any) => {
      this._gridLayoutManagerService.setGridColumnSubjects('vendors', data);
    });

    this.registerSubscription(this._gridLayoutManagerService.subscribeToColumnsChanges('vendors', (gridColumns) => {
      if (gridColumns != undefined && gridColumns !== null) {
        gridColumns = gridColumns.filter((a: any) => a.selected === true);
      }

      this._vendorsGridColumns = gridColumns;
    }));

    this._gridFields.getGridFieldsByPage('stockItems').subscribe((data: any) => {
      this._gridLayoutManagerService.setGridColumnSubjects('stockItems', data);
    });

    this.registerSubscription(this._gridLayoutManagerService.subscribeToColumnsChanges('stockItems', (gridColumns) => {
      this._stockItemsGridColumns = gridColumns;
    }));


    this._gridFields.getGridFieldsByPage('locations').subscribe((data: any) => {
      this._gridLayoutManagerService.setGridColumnSubjects('locations', data);
    });
    this.registerSubscription(this._gridLayoutManagerService.subscribeToColumnsChanges('locations', (gridColumns) => {
      this._locationsGridColumns = gridColumns;
    }));

    this._currentUser = this._securityService.currentUser;
    this._securityService.getLicense().subscribe((data: any) => {
      this._hasFieldControlLicense = !!data?.general?.fieldControl;
    });
    this._hasPurchaseOrderLicense = this._securityService.hasLicense({ license: 'purchaseOrder', baseLicense: 'stock' });
    this._pageState = PageState.ADD;

    this.GridColumsbehavior.subscribe(value => {
      if (value != undefined && value != null) {
        let pagename = value.map((a: any) => a.page).shift();
        let Gridresualt = value.filter((a: any) => a.selected === true && a.page === pagename);
        switch (pagename) {
          case 'vendors':
            this._vendorsGridColumns = Gridresualt;
            break;
          case 'locations':
            this._locationsGridColumns = Gridresualt;
            break;
          case 'stockItems':
            this._stockItemsGridColumns = Gridresualt;
            break;
          //
          default:
            break;
        }
      }
    })
  }

  imageUrl(imagepath: string) {
    let path = this._sharedService.ImageUrl(imagepath);

    return this._sharedService.ImageUrl(imagepath);
  }

  _checkMultiSitesLicense() {
    this._securityService.getLicense().subscribe((data: any) => {
      if (data.general.numberOfSites > 1) {
        this._isMultiSite = true;
      }

      if (this._isMultiSite == true) {
        var userSites = JSON.parse(localStorage.getItem('loggedInAccountSites'));
        let selectedSite = userSites[0].siteId;

        if (selectedSite == null || selectedSite == SitesEnum.AllSites) {
          this._isMultiSiteSelected = true;
          this._loadSitesDD();
        }
        else {
          if (!this._defaultLocationSettingEnabled)
            this._loadLocations();
          this._loadPurchaseOrdersDD();
          this.getStockItemDDPaging();
        }
      }
      else {
        if (!this._defaultLocationSettingEnabled)
          this._loadLocations();
        this._loadPurchaseOrdersDD();
        this.getStockItemDDPaging();
      }
    });
  }

  _AllSitesObject(): any {
    var _allSitesObj: any = {};
    _allSitesObj.code = 'All Sites';
    _allSitesObj.name = 'All Sites';
    _allSitesObj.id = 0;

    return _allSitesObj;
  }

  _loadSitesDD() {
    this._loadSites(this.sitesService, () => {
      this.siteId = this.sitesData && this.sitesData.length > 0 ? this.sitesData[0].id : null;
      this._form.patchValue({
        site: this.sitesData && this.sitesData.length > 0 ? this.sitesData[0] : null
      });

      if (!this._defaultLocationSettingEnabled) {
        this._loadLocations();
      }

      this._loadPurchaseOrdersDD();
      this.getStockItemDDPaging();
      this._loadVendorsDD();
    });
  }

  _getAccountIds() {
    let accountSiteData = localStorage.getItem('loggedInAccountSites');

    if (accountSiteData) {
      let JsonData = JSON.parse(accountSiteData);

      JsonData.forEach((s: { siteId: number, accountId: number }) => {
        this._selectedAccountIds.push(s.accountId);
        this.siteId = s.siteId; //will be set like this for now
      })
    }
  }

  onSitesChange(e: SiteLisitng) {
    let _currentVal = this._form.value.site;

    setTimeout(() => {
      if (this._inventoryGridData.length > 0 || this._form.controls['location'].value || this._form.controls['purchaseOrder'].value || this._form.controls['vendor'].value) {
        this._sharedService.okCloseClicked.subscribe((data: boolean) => {
          if (data == true) {
            this._inventoryGridData = [];
            this._selectedStockItem.setValue(null);
            this._form.controls['note'].setValue(null);
            this._form.controls['location'].setValue(null);
            this._form.controls['purchaseOrder'].setValue(null);
            this._form.controls['vendor'].setValue(null);

            if (!this._defaultLocationSettingEnabled) {
              this._loadLocations();
            }

            this._loadPurchaseOrdersDD();
            this.getStockItemDDPaging();
            this._loadVendorsDD();
          }
          else {
            this._form.patchValue({
              site: _currentVal
            });
          }
        });

        this._layoutComponent.openPopup({
          title: 'Notification',
          message: `Changing the site will clear the selected items, location, purchase order, vendor of the transaction. Continue?`
        });
      }
      else {
        if (!this._defaultLocationSettingEnabled) {
          this._loadLocations();
        }

        this._loadPurchaseOrdersDD();
        this.getStockItemDDPaging();
        this._loadVendorsDD();
      }
    }, 100);
  }
  async LoadData() {
    // this._dataService.dataTransferObservable.subscribe((item:any)=>{
    //   this._moveInventories.push(item)
    //  //this._handleInventoriesListChange(this._moveInventories);
    // })

    if (this._receiveTransactionsService.FromInventory.length > 0) {
      //this._handleInventoriesListChange(this._moveInventories,true);
      this._receiveTransactionsService.FromInventory.forEach((item: any) => {
        this._selectedStocks.push(item.stockItem);
      });

      this._returnSelectedStocksHandler(this._receiveTransactionsService.FromInventory);
    }

    this.quantityFormat = await this.quantityFormatsService.getQuantityFormatForNumericTextBox();

    this._formatService.getCostPriceFormat().subscribe((data) => {
      let selected = data.find(f => f.enabled == true);

      if (selected != null) {
        this.digitNumber = +selected.key;
      }
    });
  }

  //#region  ngOnInit
  closeTextbox(event: any) {
    //this.title=event.value;
    this._gridFields.EditPageTitle(this.page, event.value).subscribe((data: any) => {
      this.title = data.titleName;
      this._sharedService.TitleChanged.emit(true);
    });
    this.showTextBox = false;
  }
  showTextbox() {
    this.showTextBox = true;
    //document.getElementById('titleTextBox').focus();
    //this.titleTextBox.nativeElement.focus();
  }


  ngOnInit() {
    this._gridFields.getPageByName(this.page).subscribe((data) => {
      if (data.titleName) {
        this.title = data.titleName;
      }
    });

    this._getAccountIds();
    this._checkMultiSitesLicense();
    /** Format */
    this._datePickerFormat = this._formatService.dateFormat;
    this._costFormat = this._formatService.costFormatValue;
    this._initForm();
    this._sysReceivesService.getSysReceive().subscribe((data) => {
      if (data != null) {
        this._showVendorStockItemOnPOAndRece = data.showVendorStockItemOnPOAndRece ?? false;
        this._addNewStockSettingEnabled = data.addNewItemEnabled;
        this._defaultLocationSettingEnabled = this._receiveTransactionsService.FromInventory.length > 0 ? false : data.defaultLocation;
        this._receiveBatchItemsAllowDuplicateInvEnabled = data.receiveBatchItemsEnabled;
        this._receiveUDField1Show = data.udField1;
        this._receiveUDField2Show = data.udField2;
        this._receiveUDField3Show = data.udField3;
        this._receiveUDHeaderField1Show = data.udHeaderField1;
        this._receiveUDHeaderField2Show = data.udHeaderField2;
        this._receiveUDHeaderField3Show = data.udHeaderField3;
        this._receiveUDFieldDate1Show = data.udFieldDate1;
        this._receiveUDFieldDate2Show = data.udFieldDate2;
        this._receiveUDFieldDate3Show = data.udFieldDate3;
        /* Fields' Names */
        this._receiveUDField1Name = data.udField1Name;
        this._receiveUDField2Name = data.udField2Name;
        this._receiveUDField3Name = data.udField3Name;
        this._receiveUDHeaderField1Name = data.udHeaderField1Name;
        this._receiveUDHeaderField2Name = data.udHeaderField2Name;
        this._receiveUDHeaderField3Name = data.udHeaderField3Name;
        this._receiveUDFieldDate1Name = data.udFieldDate1Name;
        this._receiveUDFieldDate2Name = data.udFieldDate2Name;
        this._receiveUDFieldDate3Name = data.udFieldDate3Name;

        if (this._defaultLocationSettingEnabled) {
          this._locationsFiltered = null;
          var defaultLocation = { id: -1, code: '<Default Location>', name: '<Default Location>' };
          this._locations = [defaultLocation];
          this._locationsFiltered = [defaultLocation];
          this._form.patchValue({ location: defaultLocation });

          //this._loadItems() ;
          this.getStockItemDDPaging();
        }
        else {
          //if (!this._currentUser.isEnterprise ){ this._loadLocations(); }
        }

        if (data.printLabelsEnabled) {
          if (data.labelSize && data.labelSize.id) {
            this._barcodemodel.LabelSizeID = data.labelSize.id;
            this._barcodemodel.LabelSize = data.labelSize;
            this._barcodemodel.Row = data.labelSize.rows || data.labelRows || 1;
            this._barcodemodel.Column = data.labelSize.columns || data.labelColumns || 1;
            this._barcodemodel.customLabelPreset = false;
          }
          else if (data.labelPreset) {
            const presetId = typeof data.labelPreset === 'object' ? (data.labelPreset.id ?? data.labelPreset.Id) : data.labelPreset;
            if (presetId) {
              this._barcodemodel.LabelPresetId = Number(presetId);
              this._barcodemodel.customLabelPreset = true;
            } else {
              this._barcodemodel.customLabelPreset = false;
            }
          }
          else {
            this._barcodemodel.customLabelPreset = false;
          }

          this._printLabelsSettingsEnabled = data.printLabelsEnabled;
        }

        this._OpenAccount();
        //this._loadVendorsDD();

      }
    });

    this._printReceiptsService.getPrintReceipt().subscribe((data) => {
      this._settingsPrintReceipt = data;
    });

    this._poPreferencesService.getPOPreference().subscribe(res => {
      this._poPreference = res.validation;
    });

    this._loadPurchaseOrdersDD();

    this._form.get('location').valueChanges.subscribe((x) => {
      if (x) {
        if (x.id != -1) {
          if (!this._form.get('vendor').value) {
            setTimeout(() => {
              if (this.kendoComboVendors != undefined) {
                this.kendoComboVendors.toggle();
                this.kendoComboVendors.focus();
              }
            });
          }
          else {
            setTimeout(() => {
              if (this.kendoComboItems != undefined) {
                this.kendoComboItems.toggle();
                this.kendoComboItems.focus();
              }
            });
          }
        }
      }
    });

    this._form.get('vendor').valueChanges.subscribe((x) => {
      if (x) {
        setTimeout(() => {
          if (this.kendoComboItems != undefined) {
            this.kendoComboItems.toggle();
            this.kendoComboItems.focus();
          }
        });
      }
    });

    this._form.get('purchaseOrder').valueChanges.subscribe((x) => {
      if (x) {
        if (!this._defaultLocationSettingEnabled) {
          setTimeout(() => {
            if (this.kendoComboLocations != undefined) {
              this.kendoComboLocations.toggle();
              this.kendoComboLocations.focus();
            }
          }, 500);
        }
        else {
          setTimeout(() => {
            if (this.kendoComboItems != undefined) {
              this.kendoComboItems.toggle();
              this.kendoComboItems.focus();
            }
          });
        }
      }
    });

    this._defaultDate.valueChanges.subscribe((x) => {
      if (x) {
        this._expirationDate.setValue(new Date());
      }
    });

    this._selectedStockItem.valueChanges.subscribe((x) => {
      if (x) {
        let gridItem = this._inventoryGridData.find(r => r.itemNumber === x.number);

        if (!gridItem || (gridItem && gridItem.itemTypeId == ItemsTypes.Batch)) {
          this._inventoryCode.setValue('');


          this._itemType = this.getItemType(x.itemType?.name ?? x.itemtype?.name);
          this._itemtypeId = x.itemType?.id ?? x.itemtype?.id;
          // this._itemType = this.getItemType(x.itemType?.name);
          // this._itemtypeId = x.itemType?.id;

          ////'standard'
          if (this._itemtypeId === ItemsTypes.Standard || this._itemtypeId === ItemsTypes.NonInventory) {
            this._inventoryCode.setValue(x.number);
          }
          else {
            if (this._quantity.value
              //&& this._itemtypeId !== ItemsTypes.NonInventory
              && this._autoCodeGeneration.value) {
              //  this.runGenerateBarcode();
              let item: StockItemSummary = null;
              let counter = this._itemtypeId === ItemsTypes.Serial ?
                parseInt(this._quantity.value?.toFixed(this.digitNumber)) : 1;

              this.generateBarcode(counter).subscribe((data: any) => {
                this._inventoryCode.setValue(data.result.toString());

                if (item != null) {
                  if (item.itemType.id == 1) {
                    this._expirationDate.setValue(null);
                  }
                  let gridItem = this._inventoryGridData.find(r => r.itemNumber === item.number);
                  let _quantity = this._itemtypeId === ItemsTypes.Serial
                    ? (this._quantity.value ? parseInt(this._quantity.value) : 0) :
                    (this._quantity.value ? +this._quantity.value?.toFixed(this.digitNumber) : 0);

                  let maxrowindex = Math.max(...this._inventoryGridData.map(o => o.rowindex), 0) + 1;

                  if (!gridItem) {
                    this._inventoryGridData.push({
                      stockItemId: item.id,
                      poid: item.id,
                      stockPurchaseOrderId: 0,
                      itemNumber: item.number,
                      description: item.description,
                      quantity: _quantity,
                      uom: item.receiveUnitOfMeasure.code,
                      inventoryCode: this._inventoryCode.value,
                      expirationDate: this._expirationDate.value,
                      unitCost: item.costInfo?.cost ?? 0,
                      itemType: this.getItemType(item.itemType.name),
                      itemTypeId: item.itemType.id,
                      minQuantity: item.minqty,
                      maxQuantity: item.maxqty,
                      defaultLocation: item.defaultLocation != null ? item.defaultLocation.code : null,
                      defaultLocationId: item.defaultLocation != null ? item.defaultLocation.id : null,
                      uDField1: null,
                      uDField2: null,
                      uDField3: null,
                      uDFieldDate1: null,
                      uDFieldDate2: null,
                      uDFieldDate3: null,
                      rowindex: maxrowindex,
                      stockItemVendors: item.stockItemVendors,
                      vendorStockNumber: this.getVendorStockNumber(item)
                    });
                  }
                }
                else {

                  if (this._defaultQuantity.value) {
                    setTimeout(() => {
                      this.fillGrid();
                    });
                  }

                }
              });
            }
          }
          // if (this._defaultQuantity.value) {
          //     setTimeout(() => {
          //         this.fillGrid();
          //     });
          // }
        }
      } else {
        this._itemType = null;
        this._itemtypeId = null;
        this._inventoryCode.setValue(null);

        if (!this._defaultQuantity.value) {
          this._quantity.setValue(null);
        }

        if (this._defaultDate.value) {
          this._expirationDate.setValue(new Date());
        } else {
          this._expirationDate.setValue(null);
        }

        if (this._barcodePopupActive) {
          this._barcodePopupClose();
        }
      }
    });

    this._sortingSelected.valueChanges.subscribe((x) => {
      this._inventoryGridData.reverse();
    });

    this._quantity.valueChanges.subscribe((x) => {
      if (x && this._selectedStockItem.value && this._autoCodeGeneration.value) {
        if (this._itemType === 'serial' || !this._inventoryCode.value) {
          this.runGenerateBarcode();
        }
      }
    });

    this.loadLabels();
    this.getAuth();
    this.getLocationAuth();
    this.getPOAuth();
    this.getVendorAuth();

    // this.getDateEnabledOption();


    //Quraim
    this._dataService.dataTransferObservable.subscribe(str => {
      this._onCloseAddStockItem(str);
    });


  }
  //#endregion

  ngAfterViewInit() {
    // var inputButton = document.querySelectorAll(".k-datepicker");

    // inputButton.forEach((button: any, index: any) => {
    //     var btn = document.createElement("button");
    //     btn.setAttribute( "class", "datepickerSkipButton");

    //     var icon = document.createElement("span");
    //     icon.setAttribute("class", "datepickerSkipButton");
    //     icon.innerHTML = 'skip<img [src]="/assets/menu/'+ this._theme +'/yellow-skip-arrow.svg"/>';
    //     btn.appendChild(icon);

    //     icon.addEventListener("click", (e) => {
    //         this._quantitySubmitted();
    //     });
    //     button.parentNode.insertBefore(icon, button);
    // });
  }
  //#region  _OpenAccount
  _OpenAccount() {
    if (this._currentUser.isEnterprise) {
      setTimeout(() => {
        if (this.kendoComboAccounts != undefined) {
          this.kendoComboAccounts.toggle(true);
          this.kendoComboAccounts.focus();
        }
      });
    }
    else {
      if (!this._defaultLocationSettingEnabled) {
        setTimeout(() => {
          if (this.kendoComboLocations != undefined) {
            this.kendoComboLocations.toggle();
            this.kendoComboLocations.focus();
          }
        });
      } else {
        setTimeout(() => {
          if (this.kendoComboVendors != undefined) {
            this.kendoComboVendors.toggle();
            this.kendoComboVendors.focus();
          }
        });
      }
    }
  }
  //#endregion
  //#region  _onUploadClick
  _onUploadClick() {

    let kendoUploader = this.uploadWrapper.nativeElement.querySelector('input');
    kendoUploader.click();
  }
  //#endregion
  //#region _selectStocksHandler
  _selectStocksHandler(): void {
    this._showStocksGrid = true;
  }
  //#endregion

  //#region _returnSelectedStocksHandler
  _returnSelectedStocksHandler(e: any[]): void {

    if (this._defaultLocationSettingEnabled && !this._validateMultiDefaultLocation(this._selectedStocks)) return;

    this._showStocksGrid = false;
    this._selectedStocks.forEach((item: any) => {
      // Check if this is a deleted PO item being re-added
      if (item._deletedPOItem) {
        this._reAddDeletedPOItem(item._deletedPOItem);
        return;
      }
      this._inventoryCode.setValue('');
      this._itemType = this.getItemType(item.itemType.name);
      this._itemtypeId = item.itemType.id;

      if (this._itemType === 'standard' || !this._autoCodeGeneration.value) {

        if (this._itemType === 'standard') {
          this._inventoryCode.setValue(item.number);
          this._expirationDate.setValue(null);
        }
        if (this._itemtypeId === ItemsTypes.NonInventory) {
          this._inventoryCode.setValue(item.number);
        }
        let maxrowindex = Math.max(...this._inventoryGridData.map(o => o.rowindex), 0) + 1;
        let gridItem = this._inventoryGridData.find(r => r.itemNumber === item.number);

        let locCode = item.defaultLocation?.code;
        let locId = item.defaultLocation?.id;
        if (this._receiveTransactionsService.FromInventory.length > 0) {
          const invItem = this._receiveTransactionsService.FromInventory.find((x: any) => x.stockItem?.id === item.id);
          if (invItem && invItem.location) {
            locCode = invItem.location.code;
            locId = invItem.location.id;
          }
        }

        let _Gquantity = this._itemType === 'serial' ? (this._quantity.value ? parseInt(this._quantity.value) : 0) : (this._quantity.value ? +this._quantity.value?.toFixed(this.digitNumber) : 0);
        if (!gridItem) {
          this._inventoryGridData.push({
            stockItemId: item.id,
            poid: null, //  this._form.get('purchaseOrder')?.value == null ? null : item.id,
            itemNumber: item.number,
            description: item.description,
            quantity: _Gquantity,
            uom: item.receiveUnitOfMeasure.code,
            inventoryCode: this._inventoryCode.value,
            expirationDate: this._expirationDate.value,
            unitCost: item.costInfo?.cost ?? 0,
            itemType: this.getItemType(item.itemType.name),
            itemTypeId: item.itemType.id,
            minQuantity: item.minqty,
            maxQuantity: item.maxqty,
            stockPurchaseOrderId: 0,
            defaultLocation: locCode,
            defaultLocationId: locId,
            uDField1: null,
            uDField2: null,
            uDField3: null,
            uDFieldDate1: null,
            uDFieldDate2: null,
            uDFieldDate3: null,
            rowindex: maxrowindex,
            stockItemVendors: item.stockItemVendors,
            vendorStockNumber: this.getVendorStockNumber(item)
          });
        }
      } else {
        if (this._itemType !== 'non-inventory' && this._autoCodeGeneration.value) {
          // if(this._quantity.value?.toFixed(this.digitNumber) > 1 && this._itemtypeId === ItemsTypes.Batch){
          //   setTimeout(() => {
          //   }, 100 * this.initial);
          // }
          this.runGenerateBarcode(item);
        }
      }
    });
  }
  //#endregion

  //#region  _getStockItems
  _getStockItems = (params?: any, model?: any): Observable<DataWithPagingMetadata<any>> => {
    // When PO is selected and there are deleted items, show only deleted items
    if (this.porderid > 0 && this._poPreference == 'full' && this._deletedPOItems.length > 0) {
      const deletedItemsFormatted = this._deletedPOItems.map(item => ({
        id: item.stockItemId,
        number: item.itemNumber,
        description: item.description,
        itemType: { id: item.itemTypeId, name: item.itemType, code: item.itemType },
        receiveUnitOfMeasure: { code: item.uom },
        costInfo: { cost: item.unitCost, costType: null as any, markupPercent: null as any, markupNumber: null as any },
        defaultLocation: item.defaultLocationId ? { id: item.defaultLocationId, code: item.defaultLocation } : null,
        minqty: item.minQuantity,
        maxqty: item.maxQuantity,
        site: null as any,
        category: null as any,
        issueUnitOfMeasure: { code: item.uom },
        _deletedPOItem: item
      }));
      return new Observable(observer => {
        observer.next({
          data: deletedItemsFormatted,
          paging: { total: deletedItemsFormatted.length, page: 1, size: deletedItemsFormatted.length, count: deletedItemsFormatted.length }
        });
        observer.complete();
      });
    }
    if (model != null
      && model.filter != null
      //&& this._form.get('site').value != null
    ) {
      // model.SiteId = this._form.get('site').value;
      return this._stockItemsService.getStockItems(params, model, this._form.get('site').value?.id);
    }
  }
  //#endregion
  _closeStocksWindow(): void {
    this._showStocksGrid = false;
  }

  _onStockRowSelectionChanges(e: any[]) {
    this._selectedStocks = [];
    e.forEach((item) => {
      this._selectedStocks.push(item);
    });
  }

  _generateBarcodeClick() {
    this.runGenerateBarcode();

    if (this._itemType == 'serial') {
      setTimeout(() => {
        this._initBarCodePopupForm();
      }, 500);
    }
    else if (this._itemType == 'batch') {
      this.expirationDateInput.focus();
    }
  }

  _handleSitesFilter(value: any) {
    this._sitesFiltered = this._sites.filter((s) => s.name.toLowerCase().indexOf(value.toLowerCase()) !== -1);
  }

  _loadVendorsDD() {
    let siteIdd: number | null;

    if (!this._currentUser.isEnterprise) {
      siteIdd = this._form.get('site').value?.id ?? this.siteId;
    }

    return this._vendorsService.getVendorsListing(null, siteIdd).subscribe((data: any) => {
      //  data.unshift({ id: -1, code: "<No Vendor>", name: "<No Vendor>" }); //add on top
      this._vendors = data;
      this._vendorsFiltered = data;
    });
  }

  _handleVendorsFilter(value: any) {
    this._vendorsFiltered = this._vendors.filter((s) => s.code.toLowerCase().indexOf(value.toLowerCase()) !== -1);
  }

  _loadLocationsDDx() {

    let siteId = this._form.get('site').value;
    return this._locationsService.getLocationListingBySite(siteId).subscribe((data: any) => {
      this._locations = data;
      this._locationsFiltered = data;

      setTimeout(() => {
        if (this.kendoComboLocations != undefined) {
          this.kendoComboLocations.toggle();
          this.kendoComboLocations.focus();
        }
      });
    });
  }

  _loadLocations() {
    this._form.patchValue({
      location: null
    });

    if (!this._defaultLocationSettingEnabled) {
      const loggedInAccountSites = localStorage.getItem('loggedInAccountSites') ?? '';
      let siteIdd: number | null;

      if (!this._currentUser.isEnterprise) {
        siteIdd = this._form.get('site').value?.id ?? this.siteId;
      }

      let siteModel = { siteId: siteIdd }

      return this._locationsService.getLocationsByAccounts(siteModel).subscribe((data: any) => {
        this._locations = data;
        this._locationsFiltered = data;

        if (this._receiveTransactionsService.FromInventory.length > 0) {
          const firstItem = this._receiveTransactionsService.FromInventory[0];
          if (firstItem) {
            const targetLocId = firstItem.locationId || firstItem.location?.id;
            if (targetLocId) {
              const matchedLoc = data.find((l: any) => l.id === targetLocId);
              if (matchedLoc) {
                this._form.patchValue({
                  location: matchedLoc
                });
              }
            }
          }
        }

        setTimeout(() => {
          if (this.kendoComboLocations != undefined) {
            this.kendoComboLocations.toggle();
            this.kendoComboLocations.focus();
          }
          this._loadVendorsDD();
        });
      });
    }
  }

  _loadPurchaseOrdersDD() {
    let siteIdd: number | null;
    if (!this._currentUser.isEnterprise) {
      siteIdd = this._form.get('site').value?.id ?? this.siteId;
    }
    if (!siteIdd)
      siteIdd = 0;
    //return this._purchaseOrdersService.getPurchaseOrderListingBySite(siteId)
    return this._purchaseOrdersService.getOpenApprovedPurchaseOrderListingBySite(siteIdd)
      .subscribe((data: any) => {

        this._purchaseOrders = data;
        this._purchaseOrdersFiltered = data;;
      });
  }

  _handleLocationsFilter(value: any) {
    if (!this._defaultLocationSettingEnabled) {
      this._locationsFiltered = this._locations.filter(
        (s) => s.code.toLowerCase().indexOf(value.toLowerCase()) !== -1
      );
    }
  }

  _handlePurchaseOrdersFilter(value: any) {
    if (this._poPreference != 'notValidated') {
      this._purchaseOrdersFiltered = this._purchaseOrders.filter((s) => s.poNumber.toLowerCase().indexOf(value.toLowerCase()) !== -1);
    }
  }


  ClosePopup(event: boolean) {
    if (event == true) {
      this._closeCustomFields();
    }
  }

  porderid: number = 0;

  _handlePurchaseOrdersSelection(value: any) {
    this.porderid = 0;
    this._deletedPOItems = []; // Clear deleted items when PO changes
    if (this._poPreference == 'full' || this._poPreference == 'poNumberOnly') {
      this._inventoryGridData = [];
      if (value != null && value.id != null) {
        setTimeout(() => {
          this._purchaseOrdersService.getPurchaseOrder(value.id, PageNames.SysReceives).subscribe((data: any) => {
            if (this._poPreference == 'full' || this._poPreference == 'poNumberOnly') {
              this._form.patchValue({ vendor: data.vendor });
            }

            this.porderid = data.id;
            this.isFromSo = data.isFromSo;

            this._sOToPOPreferencesService.getSOToPOPreference().subscribe((data: any) => {
              this.isSoToPoEnable = data.autoIssueEnabled;
            });

            this.stockSalesOrderId = data.stockSalesOrderId;
            this._selectedpofromdropdownlist = data.stockPurchaseOrderDetails;
            if (this._poPreference == 'full') {
              data.stockPurchaseOrderDetails.forEach((item: PurchaseOrderDetailForReceive) => {
                let maxrowindex = Math.max(...this._inventoryGridData.map(o => o.rowindex), 0) + 1;

                let _Gquantity = this._itemType === 'serial'
                  ? (this._quantity.value ? parseInt(this._quantity.value) : 0) :
                  (this._quantity.value ? +this._quantity.value?.toFixed(this.digitNumber) : 0);
                this._inventoryGridData.push({
                  stockItemId: item.stockItem.id,
                  itemNumber: item.stockItem.number,
                  description: item.stockItem.description,
                  quantity: item.unitsReceived <= 0 ? item.unitsOrdered : (item.unitsOrdered - item.unitsReceived),
                  poid: item.id,
                  uom: item.stockItem.receiveUnitOfMeasure?.code,
                  inventoryCode: item.stockItem.itemType.id == 1 ? item.stockItem.number : null,
                  stockPurchaseOrderId: item.stockPurchaseOrderId,
                  expirationDate: null,
                  unitCost: item.unitCost > 0 ? item.unitCost : item.stockItem.costInfo?.cost ?? 0,
                  itemType: this.getItemType(item.stockItem.itemType.name),
                  itemTypeId: item.stockItem.itemType.id,
                  minQuantity: item.stockItem.minqty,
                  maxQuantity: item.stockItem.maxqty,
                  defaultLocation: item?.stockItem?.defaultLocation?.code,
                  defaultLocationId: item?.stockItem?.defaultLocation?.id,
                  uDField1: null,
                  uDField2: null,
                  uDField3: null,
                  uDFieldDate1: null,
                  uDFieldDate2: null,
                  uDFieldDate3: null,
                  rowindex: maxrowindex,
                  stockItemVendors: item.stockItem?.stockItemVendors,
                  vendorStockNumber: this.getVendorStockNumber(item.stockItem || item)
                });
              });
            }

          });
        });
      }
    }
    else {
      this._form.patchValue({
        vendor: { id: -1, code: '<No Vendor>', name: '<No Vendor>' }
      });
    }
  }

  _loadItemsDD(siteId: number, selectedStockNumber: string = null) {
    return this._stockItemsService.getStockItemsListingBySiteWithReceiveDetails(siteId, this.comboBoxpagingationParams).subscribe((data: any) => {
      if (selectedStockNumber != null) {




        // if(!this._items){
        //   this._items = data.body
        // }
        var newStock = this._items?.filter(x => x.number == selectedStockNumber)[0];
        this.quantityInput.focus();

        setTimeout(() => {
          this._selectedStockItem.setValue(newStock);
        });
      }
    });
  }

  filterarray: any[] = [];

  _loadItems() {

    const loggedInAccountSites = localStorage.getItem('loggedInAccountSites') ?? '';

    if (!this.beginScroll) {
      this.comboBoxpagingationParams = {
        currentItem: '0',
        totalbyPage: 20,
        search: this.comboBoxpagingationParams.search != '' ? this.comboBoxpagingationParams.search : '',
        page: 1
      };

      return this._stockItemsService.getStockItemsListingBySiteWithReceiveDetails(JSON.parse(loggedInAccountSites)[0].siteId, this.comboBoxpagingationParams).subscribe((data: any) => {
        this._items = data.body;
        this._itemsFiltered = data.body;
      });

    }
    else {
      return this._stockItemsService.getStockItemsListingBySiteWithReceiveDetails(JSON.parse(loggedInAccountSites)[0].siteId, this.comboBoxpagingationParams).subscribe((data: any) => {
        if (data.body.length) {
          if (this._itemsFiltered.length) {
            data.body.forEach((a: any) => {
              let resualt = this._itemsFiltered.find((d: any) => d.number === a.number);
              if (resualt === undefined) {
                this.filterarray.push(data.body.find((d: any) => d.number === a.number));
              }
            });

            this._itemsFiltered = [...this._itemsFiltered, ...this.filterarray];
            this.filterarray = [];

            if (this.comboBoxpagingationParams != null)
              this.comboBoxpagingationParams.page += 1;
          }
        }
      });
    }
  }




  _handleItemsFilter(value: any) {
    if (this.timeOut) clearTimeout(this.timeOut);
    var doneTypingInterval = 1000;  //time in ms, 5 seconds for example
    this._itemFilter = value;

    this.timeOut = setTimeout(() => {
      this.comboBoxpagingationParams.search = this._itemFilter;
      this.comboBoxpagingationParams.currentItem = '0';
      this._loadItems();
    }, doneTypingInterval);
  }

  _addNewStock() {
    var value = this._itemFilter;
    if (this._addNewStockSettingEnabled && typeof value === 'string' && this._items?.findIndex(item => item.number === value) == -1) {
      if (this._currentUser.isEnterprise) {
        var _accountSites: any[] = [];
        _accountSites.push({
          siteId: this._form.get('site').value.id,
          accountId: this._selectedAccount.value.id
        });
        model['accountSites'] = _accountSites;
      }

      var model: any = {};

      model.number = value;
      model.itemTypeId = 1;
      model.costTypeId = 1;
      model.receiveUnitOfMeasureId = 1;
      model.inventoryUnitOfMeasureId = 1;
      model.issueUnitOfMeasureId = 1;
      model['fileIds'] = [];
      model['vendorIds'] = [];
      model['stockItemAlternateCodes'] = [];

      this._stockItemsService.createStockItem(model).subscribe((response: any) => {
        if (response != null) {
          const loggedInAccountSites = localStorage.getItem('loggedInAccountSites') ?? '';
          this._loadItemsDD(this._form.get('site').value.id ?? JSON.parse(loggedInAccountSites)[0].siteId, model.number);
        }
      });
    }
  }

  _skipAddNewStock() {
    if (this.kendoComboItems != undefined) {
      this.kendoComboItems.blur();
      this.kendoComboItems.toggle();
      this.kendoComboItems.focus();
    }
  }

  _dateChanged(selectedDate: Date) {
    if (selectedDate >= this._minDate) {
      this._quantitySubmitted();
    }
  }

  _quantitySubmitted(event: any = null) {
    this.focusOutExpirationDate(null);
    this._inventoryCodeChanged()
    switch (this._itemtypeId) {
      case ItemsTypes.Serial: //'serial':
        if (this._inventoryCode.value == '' || this._inventoryCode.value == null) {
          var generateBarcodeRan = false;
          if (this._selectedStockItem.value && this._autoCodeGeneration.value) {
            this.runGenerateBarcode();
            generateBarcodeRan = true;
          }
          if (generateBarcodeRan) {
            setTimeout(() => {
              this._initBarCodePopupForm();
            }, 500);
          }
          else {
            this._initBarCodePopupForm();
          }

          return;
        }

        break;

      case ItemsTypes.Batch: //'batch':
        if (this._inventoryCode.value == '' || this._inventoryCode.value == null) {
          this.inventoryIdInput.nativeElement.focus();
          return;
        }

        break;
      case ItemsTypes.SerialwithQuantity: // 'serial-with-quantity':
        if (this._inventoryCode.value == '' || this._inventoryCode.value == null) {
          this.inventoryIdInput.nativeElement.focus();
          return;
        }

        break;
    }

    if (!this._receiveBatchItemsAllowDuplicateInvEnabled) {
      if (this._selectedStockItem != undefined && this._selectedStockItem.value != null && this._selectedStockItem.value.itemType.id === ItemsTypes.Batch) {
        if (this._inventoryCode != undefined && this._inventoryCode.value != null && this._inventoryCode.value != '') {

          if (this._inventoryGridData != undefined && this._inventoryGridData.length > 0) {
            let validate = this._inventoryGridData.filter((x: any) => x.itemTypeId == ItemsTypes.Batch && x.inventoryCode === this._inventoryCode.value);
            if (validate != undefined) {
              if (validate != null && validate.length > 0) {
                this._layoutComponent.openPopup({
                  title: 'Validation',
                  message: 'Receiving more of an existing Inventory ID # for Batch type Items is not allowed.',
                  withoutConfirm: true
                });
                return;
              }
            }
          }

          const stockLocationModel = {
            locationId: this._form.get('location').value.id,
            ListOfInventoryNumber: [this._inventoryCode.value],
            ItemTypeId: ItemsTypes.Batch,
            DefaultLocationId: 0,
            StockItemId: [this._selectedStockItem.value.id]
          };

          this._inventoriesService.getInventoryListbyNumberAndLocation(stockLocationModel).subscribe((result: any) => {
            if (result.data != undefined && result.data != null && result.data.returnCount > 0) {
              this._layoutComponent.openPopup({
                title: 'Validation',
                message: 'Receiving more of an existing Inventory ID # for Batch type Items is not allowed.',
                withoutConfirm: true
              });
              return;
            }
            else {
              if (this._selectedStockItem.value) {
                setTimeout(() => {
                  this.fillGrid();
                }, 500);
              }
              // this.showSkip = false;
            }
          });
        }
      }
      else {
        if (this._selectedStockItem.value) {
          this.fillGrid();
        }
        //   this.showSkip = false;
      }
    }
    else {
      if (this._selectedStockItem.value) {
        // if (!this._validateSingleStockItemDefaultLocation(this._selectedStockItem.value) ) return ;
        this.fillGrid();
      }
      // this.showSkip = false;

    }
  }

  _validateMultiDefaultLocation(items: any[]) {
    if (items.length > 0) {
      var issvalidate = true;
      let itemsnothavelocation = '';
      let itemswithoutDefLocation = items.filter((a: any) => a.defaultLocationId === 0 || a.defaultLocationId === undefined);

      if (itemswithoutDefLocation != undefined) {
        if ((this._defaultLocationSettingEnabled && itemswithoutDefLocation != null && itemswithoutDefLocation.length > 0)) {
          issvalidate = false;
          let itemtital: any = itemswithoutDefLocation.length > 1 ? ' Items ' : ' Item ';
          let messgevirb = itemswithoutDefLocation.length > 1 ? ' Dont ' : ' Doesnt ';
          itemswithoutDefLocation.forEach((x: any) => {
            itemsnothavelocation = x.description == null ? ' ' + itemsnothavelocation + x.itemNumber + ',' : itemsnothavelocation + x.description + ',';
          });
          this._layoutComponent.openPopup({
            title: 'Validation',
            message: 'Selected' + itemtital + itemsnothavelocation + messgevirb + ' have a default location.',
            returnAfterOkCloseClick: true,
            withoutConfirm: true
          });
          return;
        }
      }
      return issvalidate;
    }
  }

  _validateSingleStockItemDefaultLocation(items: any) {
    if (items != undefined && items != null) {
      var issvalidate = true;
      if (this._defaultLocationSettingEnabled) {
        if (items.defaultLocation === null || (Array.isArray(items.defaultLocation) && items.defaultLocation.length === 0)) {
          issvalidate = false;
          this._layoutComponent.openPopup({
            title: 'Validation',
            message: 'Selected item' + items.number + ' does not have a default location. Please select another item.',
            returnAfterOkCloseClick: true,
            withoutConfirm: true
          });
        }
      }
      return issvalidate;
    }
  }

  showSkip = false;
  addFocusClassToExpirationDate($event: any) {
    //let expDate = this.expirationDateInput;
    //ɵgetHostElement(expDate).classList.add('focusedDatepicker');
    //this.expirationDateInput.toggle(true);
    this.expirationDateInput.focus();
    // this.showSkip = true;
    //this._quantitySubmitted();
  }
  focusOutExpirationDate($event: any) {
    //let expDate = this.expirationDateInput;
    //this.ShowSkip = false;
    //ɵgetHostElement(expDate).classList.remove('focusedDatepicker');
    if (this.expirationDateInput != undefined) {
      this.expirationDateInput.toggle(false);
      this.expirationDateInput.blur();
    }
    //if(fromSkip)
    // this._quantitySubmitted();
  }
  //#endregionitem

  _validateBatchItems_ifduplicateddisable(selectfromitems: any = null) {
    const stockLocationModel = {
      locationId: this._form.get('location').value.id,
      ListOfInventoryNumber: selectfromitems != null ? this._inventoryGridData.map((a: any) => a.inventoryCode) : selectfromitems.number,
      ItemTypeId: ItemsTypes.Batch,
      StockItemId: this._inventoryGridData.filter((x: any) => x.itemTypeId == ItemsTypes.Batch).map((a: any) => a.stockItemId)
    };

    this._inventoriesService.getInventoryListbyNumberAndLocation(stockLocationModel).subscribe((result: any) => {
      if (result.data != undefined && result.data != null && result.data.returnCount > 0) {
        return true;
      }
    });

    return false;
  }

  _ValidationAndSave(e: any) {
    if (this._inventoryGridData != undefined && this._inventoryGridData.length > 0) {
      this._inventoryGridData.forEach((a: any) => {
        let inventoryValues: any[] = [];
        if (a.inventoryCode) {
          inventoryValues = a.inventoryCode.split(',');
          const hasDuplicates = new Set(inventoryValues).size !== inventoryValues.length;
          if (hasDuplicates) {
            this._layoutComponent.openPopup({
              title: 'Validation',
              message: 'Sorry, Can`t add duplicate inventory Ids',
              withoutConfirm: true
            });
            return;
          }
        }
      });
    }

    if (!this._inventoryGridData.length) {
      this._layoutComponent.openPopup({
        title: 'Validation',
        message: 'Please add the items you want to Receive.',
        withoutConfirm: true
      });

      return;
    }
    else if (!this.checkInventoriesValiation()) {
      this._layoutComponent.openPopup({
        title: 'Validation',
        message: 'Please fill the required fields in the grid.',
        withoutConfirm: true
      });

      return;
    }
    else if (!this._defaultLocationSettingEnabled && this._form.get('location').value == null) {
      this._layoutComponent.openPopup({
        title: 'Validation',
        message: 'Please Choose a location From List.',
        withoutConfirm: true
      });

      return;
    }
    else if (this._form.invalid) {
      this._invalidForm = true;
    }
    else if (this._isvalidpocheckQyafterinsertiontoGrid()) {
      this._additionalErrors = [];
      this._additionalErrors[0] = [' Error Not enough available quantity available Qty `'];
      this._invalidavailableqty = true;

      return;
    }
    else if (!this._inventoryChechNumberOnBatch()) {
      this._additionalErrors = [];
      this._additionalErrors[0] = [' Please Enter Inventory ID Code`'];
      this._invalidavailableqty = true;

      return;
    }

    if (this._defaultLocationSettingEnabled && !this._validateMultiDefaultLocation(this._inventoryGridData)) {
      return;
    }

    if (!this._receiveBatchItemsAllowDuplicateInvEnabled) {
      if (this._inventoryGridData != undefined && this._inventoryGridData.length > 0) {
        let iGridHaveBatchItems = this._inventoryGridData.filter((x: any) => x.itemTypeId == ItemsTypes.Batch);

        //===========================Condation to check grid have batch items ====================================
        if (iGridHaveBatchItems != undefined && iGridHaveBatchItems != null && iGridHaveBatchItems.length > 0) {

          let batchvalue = this._inventoryGridData.filter((x: any) => x.itemTypeId == ItemsTypes.Batch);

          if (batchvalue != undefined) {
            batchvalue.forEach((a: any) => {
              let validate = this._inventoryGridData.filter((x: any) => x.itemTypeId == ItemsTypes.Batch && x.inventoryCode === a.inventoryCode);

              if (validate != null) {
                if (validate.length > 1) {
                  this._layoutComponent.openPopup({
                    title: 'Validation',
                    message: 'Receiving more of an existing Inventory ID # for Batch type Items is not allowed.',
                    withoutConfirm: true
                  });
                }

                return;
              }
            });
          }

          const stockLocationModel = {
            locationId: this._form.get('location').value.id,
            ListOfInventoryNumber: this._inventoryGridData.map((a: any) => a.inventoryCode),
            ItemTypeId: ItemsTypes.Batch,
            StockItemId: this._inventoryGridData.filter((x: any) => x.itemTypeId == ItemsTypes.Batch).map((a: any) => a.stockItemId)
          };
          this._inventoriesService.getInventoryListbyNumberAndLocation(stockLocationModel).subscribe((result: any) => {
            if (result.data != undefined && result.data != null && result.data.returnCount > 0) {
              this._layoutComponent.openPopup({
                title: 'Validation',
                message: 'Receiving more of an existing Inventory ID # for Batch type Items is not allowed.',
                withoutConfirm: true
              });

              return;
            }
            else {
              this._onSave(e);
            }
          });

        }
        else {
          this._onSave(e);
        }
        //=======================================================================================================
      }
    }
    else {
      this._onSave(e);
    }
  }

  _onSave(e: any) {
    if (this._uploadedStream.length > 0 || this._selectedExistingFiles.length > 0) {
      this._saveTransactionFiles();
    }
    else {
      this._addReceiveTransaction(null);
    }
  }

  _saveTransactionFiles() {
    let newFiles = [...this._uploadedStream];
    let existingFiles = [...this._selectedExistingFiles];

    if ((newFiles != undefined && newFiles.length > 0) || (existingFiles != undefined && existingFiles.length > 0)) {
      let _filesModel: any[] = [];

      newFiles.forEach(n => {
        let model: any = {};
        model.stream = n.stream;
        model.size = n.size;
        model.type = n.type;
        model.name = n.name ? n.name.substring(0, n.name.lastIndexOf('.')) : '';
        model.exension = n.name.substring(n.name.lastIndexOf(".") + 1).toLowerCase();
        model.typesToChecks = this._allowedFileTypes;
        model.existingFileId = n.existingFileId;
        model.fileSourceId = fileSources.receiveTransaction;
        _filesModel.push(model);
      });

      this._filesService.createFileRange(_filesModel).subscribe((response: number[]) => {
        if (response != null) {
          existingFiles.forEach((v) => {
            let ext = response.find(r => r == v.existingFileId);

            if (ext == undefined) {
              response.push(v.existingFileId);
            }
          });

          this._addReceiveTransaction(response);
        }
      });
    }
  }

  _addReceiveTransaction(fileIds?: number[]) {
    this.transactionId = null;
    this._invalidForm = false;
    const formModel = this._form.value;
    let model: any = {};
    model['entryDate'] = formModel.date ?? this._form.get('date')?.value;
    model['notes'] = formModel.note;
    model['siteId'] = formModel.site?.id ?? this.siteId;
    model['vendorId'] = formModel.vendor?.id;
    model['locationId'] = formModel.location?.id;
    model['stockPurchaseOrderId'] = formModel.purchaseOrder?.id;
    model['stockPurchaseOrderPoNumber'] = '';
    model['udHeaderField1'] = formModel.udHeaderField1;
    model['udHeaderField2'] = formModel.udHeaderField2;
    model['udHeaderField3'] = formModel.udHeaderField3;

    model['items'] = this._inventoryGridData.map((x) => {
      return {
        stockPurchaseOrderDetailsId: formModel.purchaseOrder?.id == null ? null : x.poid,//?? null,
        stockItemId: x.stockItemId,
        stockPurchaseOrderId: x.stockPurchaseOrderId,
        itemTypeId: x.itemTypeId,
        minQuantity: x.minQuantity,
        maxQuantity: x.maxQuantity,
        quantity: parseInt(x.quantity.toString()),
        inventoryNumber: (x.inventoryCode == null && x.itemTypeId == 4) ? x.itemNumber : x.inventoryCode,
        expirationDate: x.expirationDate,
        locationId: this._defaultLocationSettingEnabled ? x.defaultLocationId : model['locationId'],
        uDField1: x.uDField1,
        uDField2: x.uDField2,
        uDField3: x.uDField3,
        uDFieldDate1: x.uDFieldDate1,
        uDFieldDate2: x.uDFieldDate2,
        uDFieldDate3: x.uDFieldDate3,
        unitCost: x.unitCost,
        siteId: formModel.site?.id ?? this.siteId
      };
    });

    model['stockPurchaseOrderPoNumber'] = null;
    model['poPreference'] = this._poPreference;

    if (this._poPreference == 'notValidated' && formModel.purchaseOrder != null) {
      model['stockPurchaseOrderPoNumber'] = formModel.purchaseOrder;
    } else if ((this._poPreference == 'full' || this._poPreference == 'poNumberOnly') && formModel.purchaseOrder != null) {
      model['stockPurchaseOrderPoNumber'] = formModel.purchaseOrder.poNumber;
    }

    if (fileIds) {
      model['stockReceiveFiles'] = fileIds.map((v) => {
        return { FileId: v }
      });
    }
    else {
      model['stockReceiveFiles'] = null;
    }
    this._receiveTransactionsService.createReceive(model).subscribe((data: any) => {
      if (data.extraData == "error" && data.message == "Sorry, can't add duplicate inventory IDs.") {
        this._layoutComponent.openPopup({
          title: 'Error',
          message: data.message,
          returnAfterOkCloseClick: true,
          withoutConfirm: true
        });
        return
      }
      var msg = '';
      this._receiveTransactionsService.FromInventory = []
      if (data != null && data.message != null) {
        msg = 'Receive Transaction # ' + data.message + ' has been processed successfully.';
        this.transactionId = parseInt(data.responseId);
        //if(this._form.get("site").value)
        this._loadPurchaseOrdersDD();
      }

      this._sOToPOPreferencesService;

      if (this.isSoToPoEnable && this.isFromSo && this.stockSalesOrderId != 0) {
        this._issueTransactionsService.SelectedSalesOrderId = 0;
        this._issueTransactionsService.SelectedSalesOrderId = this.stockSalesOrderId
        this.router.navigate(['stock/transaction/issue']);
      }

      this._layoutComponent.openPopup({
        title: 'Alert',
        message: msg,
        returnAfterOkCloseClick: true,
        withoutConfirm: true
      });

      if (this._printReceipt?.value && !(this._printLabelsSettingsEnabled && this._printLabel.value)) {
        if (this._settingsPrintReceipt?.receiveReportId > 0) {
          this._layoutComponent.openDialogForm(ReportViewerPopupComponent, PageState.VIEW, { reportId: this._settingsPrintReceipt.receiveReportId, transactionId: this.transactionId });
          this._onClear();
        }
        else {
          this._reportService.ReportsByCategoryAllSitesOnly('receiveHistory').subscribe(
            (x: any) => {
              this.receiveReports = x;
              this.showReports = true;
            });
        }
      }
      else {
        // this._onClear();
      }
      this._printLabelsEnabled = this._printLabelsSettingsEnabled && this._printLabel.value;
      // for printing stock labels
      this._barcodemodel.transactionId = this.transactionId;
      this._barcodemodel.isOneLineItem = this._isOneLineItem;
      if (this._printLabelsEnabled) {
        if (data.returnValue) {
          this._barcodemodel.Column = 1;
          this._barcodemodel.Row = 1;
          this._barcodemodel.BarcodeValues = [];
          data.returnValue.forEach((element: any) => {
            const barcodeNumber = element.stockItem?.number || element.inventoryNumber || '';
            const qty = Math.floor(Number(element.quantityReceived || element.quantity || 1));
            if (this._isOneLineItem || qty <= 1) {
              this._barcodemodel.BarcodeValues.push({ 'BarcodeNumber': barcodeNumber });
            } else {
              for (let i = 0; i < qty; i++) {
                this._barcodemodel.BarcodeValues.push({ 'BarcodeNumber': barcodeNumber });
              }
            }
          });
        }
        this._previewWindow = true;
        // this._printLabel.setValue(null);
        // this._onClear();
      }
      if (!this._printReceipt?.value) {
        this._onClear();
      }
    }, (err) => {
      this._layoutComponent.openPopup({
        title: 'Error',
        message: err,
        returnAfterOkCloseClick: true,
        withoutConfirm: true
      });

    });
  }

  closeReport() {
    this.showReports = false;
  }

  _removeHandler({ sender, dataItem }: any) {
    // Track deleted PO items for re-adding later
    if (dataItem.poid && dataItem.stockPurchaseOrderId) {
      this._deletedPOItems.push(dataItem);
    }
    this._inventoryGridData = this._inventoryGridData.filter((x: any) => x.rowindex != dataItem.rowindex);
  }

  _onUnitCostChange(item: ReceiveTransaction) {
    if (!item.unitCost)
      item.unitCost = 0;
  }

  _onQuantityChange(e: number, item: ReceiveTransaction) {
    this.userinputqty = 0;
    item.quantity = parseInt(e?.toFixed(this.digitNumber));
    this._invalidForm = false;
    if (this._selectedpofromdropdownlist != null) {
      if (this.porderid > 0) {
        this._additionalErrors = [];
        this._invalidavailableqty = false;
        if (this._isvalidpocheckQyafterinsertiontoGrid()) {
          this._invalidavailableqty = true;
          this._additionalErrors[0] = ['Not enough available quantity available Qty is '];
        }
      }
    }

    if (item.itemType === 'serial') {
      var _currenttem = this._inventoryGridData.filter((x: any) => x.stockItemId == item.stockItemId);
      if (_currenttem != null && _currenttem.length > 0) {
        _currenttem[0].quantity = Math.round(e)

      }
      this.generateBarcode(parseInt(e?.toFixed(this.digitNumber)))
        .subscribe((data: any) => {
          item.inventoryCode = data.result.toString();
        });
    }
  }

  _pomaxvalueusermustenter(dataItem: any) {
    if (this.porderid > 0) {
      let rowitem = this._selectedpofromdropdownlist.filter((d: any) => d.id == dataItem.poid).shift();
      if (rowitem !== undefined)
        return (rowitem.unitsOrdered - rowitem.unitsReceived);
    }
    return Number.MAX_VALUE;
  }

  _inventoryChechNumberOnBatch(): boolean {
    let isvalid = true;
    this._additionalErrors = [];
    this._inventoryGridData.forEach((item: any) => {
      if (item.itemTypeId === 3) {
        if (item.inventoryCode == null || item.inventoryCode == undefined || item.inventoryCode == '') {
          isvalid = false;
        }
      }
    });
    return isvalid;
  }
  _isvalidpocheckQyafterinsertiontoGrid() {
    if (this.porderid > 0) {
      let _invalidavailableqty = false;
      this._inventoryGridData.forEach((item: any) => {
        let actualqty = this._selectedpofromdropdownlist.filter((d: any) => d.id == item.poid).shift();

        let actualqtyx = this._selectedpofromdropdownlist.filter((d: any) => d.id == item.poid).map((q: any) => q.unitsOrdered).shift();

        if (actualqty == undefined && actualqty == null && this._poPreference == 'poNumberOnly') {
          actualqty = {
            unitsOrdered: 0,
            unitsReceived: 0
          }
        }

        if (item.quantity > (actualqty.unitsOrdered - actualqty.unitsReceived)) {
          _invalidavailableqty = true;
        }

      });


      return _invalidavailableqty;
    }
  }

  /*_onQuantityBlur(e: any) {
    let _data = e?.target.value;
    item.quantity = parseInt(_data.toFixed(this.digitNumber));
      if (item.itemType === 'serial') {
        var _currenttem = this._inventoryGridData.filter((x: any) => x.stockItemId == item.stockItemId);
        if(_currenttem != null && _currenttem.length > 0){
          _currenttem[0].quantity = parseInt(_data.toFixed(this.digitNumber));
        }
      }
    }*/
  _onUDFieldChange(e: any, item: ReceiveTransaction, udField: string) {
    switch (udField) {
      case 'uDField1':
        item.uDField1 = e.target.value;
        break;
      case 'uDField2':
        item.uDField2 = e.target.value;
        break;
      case 'uDField3':
        item.uDField3 = e.target.value;
        break;
      case 'uDFieldDate1':
        item.uDFieldDate1 = e;
        break;
      case 'uDFieldDate2':
        item.uDFieldDate2 = e;
        break;
      case 'uDFieldDate3':
        item.uDFieldDate3 = e;
        break;
      default:
        break;
    }
  }

  _onInventoryCodeChange(e: any, item: ReceiveTransaction) {

    if (!this._receiveBatchItemsAllowDuplicateInvEnabled && item.itemTypeId === ItemsTypes.Batch) {
      let gridItem = this._inventoryGridData.find(r => r.itemTypeId === ItemsTypes.Batch
        && r.inventoryCode === e);
      if (gridItem) {
        var data = this._inventoryGridData;
        this._layoutComponent.openPopup({
          title: 'Validation',
          message: 'Receiving more of an existing Inventory ID # for Batch type Items is not allowed.',
          returnAfterOkCloseClick: true,
          withoutConfirm: true
        });
        this._inventoryGridData = [];
        setTimeout(() => {
          this._inventoryGridData = data;
        });
        return;

      }
    }
    item.inventoryCode = e;
    let clearerror = true;
    this._inventoryGridData.forEach((a: any) => {
      if (a.itemTypeId != ItemsTypes.NonInventory) {
        if (a.inventoryCode === '' || a.inventoryCode === null) {
          clearerror = false;
        }
      }
    })

    if (clearerror) {
      this._additionalErrors = [];
    }


  }

  _onExpirationDateChange(e: any, item: ReceiveTransaction) {
    item.expirationDate = e;
  }

  _openForm(componentName: string) {
    this._isDialiog = true;
    this._dialogComponentName = componentName;

    let model: any = {};
    if (componentName === 'stockItems') {
      model.number = this._itemFilter;
      model.locationId = this._form.get('location').value?.id;
      model.location = this._form.get('location').value;
      model.defaultLocationId = this._form.get('location').value?.id;
      model.defaultLocation = this._form.get('location').value;
    }
    this._dialogModel = { model: model, pageState: PageState.ADD, reload: 'model', filesErrorIcon: fileSources.receiveTransaction, accessForm: 'stockItems' };
  }


  _loadLocationsDD(siteId: number) {
    if (!this._defaultLocationSettingEnabled) {
      return this._locationsService.getLocationListingBySite(siteId)
        .subscribe((data: any) => {
          this._locations = data;
          this._locationsFiltered = data;

          if (this._receiveTransactionsService.FromInventory.length > 0) {
            const firstItem = this._receiveTransactionsService.FromInventory[0];
            if (firstItem) {
              const targetLocId = firstItem.locationId || firstItem.location?.id;
              if (targetLocId) {
                const matchedLoc = data.find((l: any) => l.id === targetLocId);
                if (matchedLoc) {
                  this._form.patchValue({
                    location: matchedLoc
                  });
                }
              }
            }
          }

          setTimeout(() => {
            //this.kendoComboLocations.toggle(true);
            if (this.kendoComboLocations != undefined)
              this.kendoComboLocations.focus();
          });
        });
    }
  }
  _closeDialog(event: any) {
    if (event?.response) {
      let sitId = this._form.controls.site.value;
      let gtt = this._poPreference;
      let givedd = this._form.get('purchaseOrder').value;
      if (event.component == 'locations') {
        this._loadLocationsDD(sitId ? sitId : event.response.siteId);
        this._form.get('location').setValue(event.response);
        this._isDialiog = event.open;
      }

      if (event.component == 'vendors') {
        this._loadVendorsDD();
        this._form.get('vendor').setValue(event.response);
        this._isDialiog = event.open;

      }
      if (event.component == 'purchaseOrders') {
        this._loadPurchaseOrdersDD();
        this._form.get('purchaseOrder').setValue(event.response);
        this._handlePurchaseOrdersSelection(this._form.get('purchaseOrder').value);
        this._isDialiog = event.open;

      }
      if (event.component == 'stockItems') {
        this._onCloseAddStockItem(event);
        this._isDialiog = event.open;
      }


    } else {
      this._isDialiog = event;
    }
  }
  _onCloseAddStockItem(data: any) {
    if (data?.component !== 'stockItems') {
      return;
    }
    let newStockItem = data.response;
    if (this._itemsFiltered == undefined) {
      this._itemsFiltered = [];
    }
    if (this._itemsFilteredNew == undefined) {
      this._itemsFilteredNew = [];
    }
    // this._loadItemsDD(this._form.get('site').value?.id ?? data.response.siteId, data.response.number);
    if (newStockItem && !this._itemsFilteredNew.find(x => x.id === newStockItem.id)) {
      this._itemsFiltered.push(newStockItem);
      this._itemsFilteredNew.push(newStockItem);
      this._selectedStockItem.setValue(newStockItem);

      // Automatically bind the newly added item to the grid
      this.fillGrid();
    }
  }


  _onClear() {
    this._selectedDocumentsKeys = [];
    this._uploadedStream = [];
    this._selectedExistingFiles = [];
    this._uploaderSelectMessage = 'Upload file..';

    const loggedInAccountSites = localStorage.getItem('loggedInAccountSites') ?? '';
    //this.transactionId = null;
    this._initForm();
    this._form.patchValue({
      date: new Date(),
      stream: null,
    });
    this.porderid = 0;
    this._additionalErrors = [];
    this._invalidavailableqty = false;

    this._receiveTransactionsService.FromInventory = [];

    this._selectedAccount.setValue(null);
    this._form.controls['note'].setValue(null);
    this._TransactionNotes.setValue(null);
    this._expirationDate.setValue(null);
    this._inventoryCode.setValue(null);
    this._autoCodeGeneration.setValue(null);
    this._defaultDate.setValue(null);
    this._defaultQuantity.setValue(null);
    this._inventoryGridData = [];
    this._printReceipt.setValue(null);
    this._printLabel.setValue(null);
    this._isOneLineItem = true;
    this.showReports = false;
    if (!this._currentUser.isEnterprise && !this._defaultLocationSettingEnabled) {
      setTimeout(() => {
        if (this.kendoComboLocations != undefined) {
          this.kendoComboLocations.toggle();
          this.kendoComboLocations.focus();
        }
      });
    }
    else {
      setTimeout(() => {
        if (this.kendoComboAccounts != undefined) {
          this.kendoComboAccounts.toggle(true);
          this.kendoComboAccounts.focus();
        }
      });
    }

    if (this._defaultLocationSettingEnabled) {
      var defaultLocation = { id: -1, code: '<Default Location>', name: '<Default Location>' };
      this._locations = [defaultLocation];
      this._locationsFiltered = [defaultLocation];
      this._form.patchValue({
        location: defaultLocation
      });
    }
  }
  _inventoryCodeChanged() {
    let inventoryValues: any[] = [];
    if (this._inventoryCode.value) {
      inventoryValues = this._inventoryCode.value.split(', ');
      const hasDuplicates = new Set(inventoryValues).size !== inventoryValues.length;
      if (hasDuplicates) {
        this._layoutComponent.openPopup({
          title: 'Validation',
          message: 'Sorry, Can`t add duplicate inventory Ids',
          returnAfterOkCloseClick: true,
          withoutConfirm: true
        });
      }
    }
  }
  _initBarCodePopupForm() {
    if (!this._barcodePopupActive) {
      let inventoryValues: any[] = [];
      if (this._inventoryCode.value) {
        inventoryValues = this._inventoryCode.value.split(', ');
        const hasDuplicates = new Set(inventoryValues).size !== inventoryValues.length;
        if (hasDuplicates) {
          this._layoutComponent.openPopup({
            title: 'Validation',
            message: 'Sorry, Can`t add duplicate inventory Ids',
            returnAfterOkCloseClick: true,
            withoutConfirm: true
          });
        }
      }

      let record: any = {};
      for (let i = 0; i < this._quantity.value?.toFixed(this.digitNumber); i++) {
        record['field' + i] = inventoryValues[i] ? [inventoryValues[i], Validators.required] : [null, Validators.required];
        this._barcodePopupFormFields.push('field' + i);
      }

      this._barcodePopupForm = this._fb.group(record);
      this._barcodePopupActive = true;
      this._layoutManager.applyOverly();
    }
  }

  _barcodePopupClose() {
    this._barcodePopupFormFields = [];
    this._barcodePopupActive = false;
    this._layoutManager.removeOverlay();
  }

  _onBarcodePopupClear(field?: string) {
    if (field) {
      this._barcodePopupForm.get(field).setValue(null);
    } else {
      this._barcodePopupForm.reset();
    }
  }

  //#region  _onBarcodePopupSave
  _onBarcodePopupSave() {
    let checkValid: boolean = true;
    let counter = 0;
    let inventoryCode = '';
    let inventoryCodeList: number[] = [];
    Object.keys(this._barcodePopupForm.controls).forEach(key => {
      if (counter > 0) {
        inventoryCode += ',';
      }

      let fieldValue = this._barcodePopupForm.get(key).value;
      if (fieldValue) {
        inventoryCode += fieldValue;
      }
      /** inventoryCodeList */
      if (inventoryCodeList.length > 0 && inventoryCodeList.filter(c => c.valueOf() == fieldValue).length)
        checkValid = false;

      inventoryCodeList.push(fieldValue);
      counter++;
    });

    this._inventoryCode.setValue(inventoryCode);
    if (checkValid) {
      this._barcodePopupClose();
      this._quantitySubmitted();
    } else {
      this._layoutComponent.openPopup({
        title: 'Validation',
        message: 'Sorry, Can`t add duplicate inventory Ids',
        returnAfterOkCloseClick: true,
        withoutConfirm: true
      });

    }

  }
  //#endregion
  _barcodePopupGenerateBarcode(field?: string) {

    if (!field) {
      for (const key in this._barcodePopupForm.controls) {
        if (!this._barcodePopupForm.get(key).value) {
          field = key;
          break;
        }
      }
    }

    if (field) {
      this.generateBarcode(1)
        .subscribe((data: any) => {
          this._barcodePopupForm.get(field).setValue(data.result.toString());
        });
    }
  }

  private runGenerateBarcode(item: StockItemSummary = null) {
    let counter = this._itemtypeId === ItemsTypes.Serial ? parseInt(this._quantity.value?.toFixed(this.digitNumber)) : 1;
    this.generateBarcode(counter)
      .subscribe((data: any) => {
        this._inventoryCode.setValue(data.result.toString());
        if (item != null) {
          if (item.itemType.id == 1) {
            this._expirationDate.setValue(null);
          }
          let gridItem = this._inventoryGridData.find(r => r.itemNumber === item.number);
          let _itemTypeName = this.getItemType(data.itemType?.name);
          let _quantity = this._itemtypeId === ItemsTypes.Serial ? (this._quantity.value ? parseInt(this._quantity.value) : 0) :
            (this._quantity.value ? +this._quantity.value?.toFixed(this.digitNumber) : 0);
          let maxrowindex = Math.max(...this._inventoryGridData.map(o => o.rowindex), 0) + 1;

          if (!gridItem) {
            let locCode = item.defaultLocation != null ? item.defaultLocation.code : null;
            let locId = item.defaultLocation != null ? item.defaultLocation.id : null;
            if (this._receiveTransactionsService.FromInventory.length > 0) {
              const invItem = this._receiveTransactionsService.FromInventory.find((x: any) => x.stockItem?.id === item.id);
              if (invItem && invItem.location) {
                locCode = invItem.location.code;
                locId = invItem.location.id;
              }
            }
            this._inventoryGridData.push({
              stockItemId: item.id,
              poid: item.id,
              stockPurchaseOrderId: 0,
              itemNumber: item.number,
              description: item.description,
              quantity: _quantity,// this._quantity.value ? +this._quantity.value?.toFixed(this.digitNumber) : 0,
              uom: item.receiveUnitOfMeasure.code,
              inventoryCode: this._inventoryCode.value,
              expirationDate: this._expirationDate.value,
              unitCost: item.costInfo?.cost ?? 0,
              itemType: this.getItemType(item.itemType.name),
              itemTypeId: item.itemType.id,
              minQuantity: item.minqty,
              maxQuantity: item.maxqty,
              defaultLocation: locCode,
              defaultLocationId: locId,
              uDField1: null,
              uDField2: null,
              uDField3: null,
              uDFieldDate1: null,
              uDFieldDate2: null,
              uDFieldDate3: null,
              rowindex: maxrowindex,
              stockItemVendors: item.stockItemVendors || data?.stockItemVendors,
              vendorStockNumber: this.getVendorStockNumber(item)
            });
          }
        }
      });
  }
  isWhitespace(value: string): boolean {
    // Use trim() to remove leading and trailing whitespace, then check if the resulting string is not empty
    if (typeof value === 'string') {
      var test = value.trim() == '';
      return value.trim() == '';
    }
  }
  private checkInventoriesValiation(): boolean {
    let validation = true;
    for (let item of this._inventoryGridData) {
      if (!item.inventoryCode || this.isWhitespace(item.inventoryCode)) {
        validation = false;
      }
      if (item.itemType === 'standard') {
        if (item.quantity <= 0) {
          validation = false;
        }
      }

      if (item.itemType === 'non-inventory') {
        if (item.quantity <= 0) {
          validation = false;
        }
      }

      if (item.itemType !== 'non-inventory' && item.itemType !== 'standard') {
        //===========================NEED BUSSINES DESCRABTION TO VALIDATE THIS CONDATION PLZ CHECK WITH QA ======
        if (item.itemTypeId != 3) {
          if (item.quantity <= 0 || !item.inventoryCode) {
            validation = false;
          }
        }
        else {
          if (item.quantity <= 0 || !item.itemNumber) {
            validation = false;
          }

        }
      }
    }

    return validation;
  }

  private getItemType(itemTypeName: string) {
    switch (itemTypeName) {
      case 'Standard':
        return 'standard';
      case 'Serial':
        return 'serial';
      case 'Batch':
        return 'batch';
      case 'Non Inventory':
        return 'non-inventory';
      case 'Serial with Quantity':
        return 'serial-with-quantity';
    }
  }

  private generateBarcode(quantity: number) {
    return this._barcodeGeneratorsService
      .getBarcode('inventories', quantity);
  }

  private _initForm() {
    const loggedInAccountSites = localStorage.getItem('loggedInAccountSites') ?? '';
    let initialSite = this._model?.site;
    if (this._receiveTransactionsService.FromInventory.length > 0) {
      const firstItem = this._receiveTransactionsService.FromInventory[0];
      if (firstItem && firstItem.site) {
        initialSite = firstItem.site;
      }
    }
    this._form = this._fb.group({
      date: [new Date(), this.getLabel('LBL_ReceiveDateTime')?.isRequired ? Validators.required : null],
      //site: [this._model?.site ?? this.siteId, Validators.required],// [JSON.parse(loggedInAccountSites)[0].siteId, Validators.required],
      site: [initialSite, Validators.required],// [JSON.parse(loggedInAccountSites)[0].siteId, Validators.required],
      purchaseOrder: [null, this.getLabel('LBL_ReceivePO')?.isRequired ? Validators.required : null],
      vendor: [null, this.getLabel('LBL_ReceiveVendor')?.isRequired ? Validators.required : null],
      location: [null, Validators.required],
      note: [null, this.getLabel('LBL_ReceiveTransactionNote')?.isRequired ? Validators.required : null],
      description: [this._model && this._model.description, this.getLabel('LBL_CatDesc')?.isRequired ? Validators.required : null],
      udHeaderField1: [this._model?.udHeaderField1 || null],
      udHeaderField2: [this._model?.udHeaderField2 || null],
      udHeaderField3: [this._model?.udHeaderField3 || null],
      stream: [null],
    });
    if (this._defaultLocationSettingEnabled) {
      this._locationsFiltered = null;
      var defaultLocation = { id: -1, code: '<Default Location>', name: '<Default Location>' };
      this._locations = [defaultLocation];
      this._locationsFiltered = [defaultLocation];
      this._form.patchValue({
        location: defaultLocation
      });
    }
    this.getDateEnabledOption();
  }
  //#region fillGrid
  private fillGrid() {
    if (!this._validateSingleStockItemDefaultLocation(this._selectedStockItem.value)) return;

    let item = this._selectedStockItem.value;
    let gridItem = this._inventoryGridData.find(x => x.itemNumber === item.number);
    if (!gridItem || (gridItem && (item.itemType?.name.toLocaleLowerCase() == 'batch' || item.itemtype?.name.toLocaleLowerCase() == 'batch'))) {
      this._stockItemsService.getStockItem(item.id).subscribe((data) => {
        if (item.itemType?.id == ItemsTypes.Standard || item.itemtype?.id == ItemsTypes.Standard) {
          this._expirationDate.setValue(null);
        }

        let _itemTypeName = this.getItemType(data.itemType.name);
        let maxrowindex = Math.max(...this._inventoryGridData.map(o => o.rowindex), 0) + 1;
        let _gQuantity = _itemTypeName === 'serial'
          ? (this._quantity.value ? Math.round(this._quantity.value) : 0) :
          (this._quantity.value ? +this._quantity.value?.toFixed(this.digitNumber) : 0);
        this._inventoryGridData.push({
          stockItemId: data.id,
          stockPurchaseOrderId: 0,
          poid: this.porderid > 0 ? this.porderid : null,
          itemNumber: item.number,
          description: data.description,
          quantity: _gQuantity,
          uom: data.receiveUnitOfMeasure.code,
          inventoryCode: this._inventoryCode.value,
          expirationDate: this._expirationDate.value,
          unitCost: data.costInfo?.cost ?? 0,
          itemType: this.getItemType(data.itemType.name),
          itemTypeId: item.itemType?.id ?? item.itemtype?.id ?? data.itemType?.id,
          minQuantity: item.minQuantity ?? item.minqty ?? data.minqty,
          maxQuantity: item.maxQuantity ?? item.maxqty ?? data.maxqty,
          defaultLocation: item.defaultLocation != null ? (item.defaultLocation.code ?? data.defaultLocation?.code) : (data.defaultLocation?.code ?? null),
          defaultLocationId: item.defaultLocation != null ? (item.defaultLocation.id ?? data.defaultLocation?.id) : (data.defaultLocation?.id ?? null),
          uDField1: null,
          uDField2: null,
          uDField3: null,
          uDFieldDate1: null,
          uDFieldDate2: null,
          uDFieldDate3: null,
          rowindex: maxrowindex,
          stockItemVendors: data.stockItemVendors || item.stockItemVendors,
          vendorStockNumber: this.getVendorStockNumber(data)
        });

        this._selectedStockItem.setValue(null);
        this._inventoryCode.setValue(null);

        setTimeout(() => {
          if (this.kendoComboItems != undefined) {
            this.kendoComboItems.toggle();
            this.kendoComboItems.focus();
          }
        });
      });
    } else {
      this._selectedStockItem.setValue(null);
      this._layoutComponent.openPopup({
        title: 'Validation',
        message: 'This item is already added to the grid. Please select another item.',
        returnAfterOkCloseClick: true,
        withoutConfirm: true
      });
    }
  }
  //#endregion
  // private sortByDate(sorting: string): void {
  //     if (sorting === 'desc') {
  //         this._inventoryGridData.sort((a: ReceiveTransaction, b: ReceiveTransaction) => {
  //             return a.expirationDate > b.expirationDate ? -1 : 1;
  //         });
  //     } else {
  //         this._inventoryGridData.sort((a: ReceiveTransaction, b: ReceiveTransaction) => {
  //             return a.expirationDate > b.expirationDate ? 1 : -1;
  //         });
  //     }
  // }

  _editFormState() {
    this._pageState = PageState.EDIT_FIELDS;
  }

  _returnAddNew() {
    this._pageState = PageState.ADD;
  }

  _openRenameForm(objectCode: string, isMandatory: boolean = false, onlyRequired: boolean = false, hasRequired: boolean = false) {
    this._selectedLabelText = this.getLabel(objectCode)?.text;
    this._selectedLabelObjectCode = objectCode;
    //todo send system field label id
    //return;
    //open form once label id is set
    this._editFormActive = true;
    this._isRenameFormValue = true;
    this._isRenameCustomFormValue = false;
    this._isRenameLabel = true;
    this._isMandatory = isMandatory;
    this._isTransaction = true;
    this._onlyRequired = onlyRequired;
    this._hasRequired = hasRequired;
  }

  _closeCustomFields() {
    this._editFormActive = false;
    this._isCustomfieldsFormValue = false;
    this._isAddTabFormValue = false;
    this._isRenameFormValue = false;
    // this.loadCustomFields(this._model?.id?.toString());
    this.loadLabels();
    // this.getFormTabs();
    this.getAuth();
    this._isTransaction = false;
    this._onlyRequired = false;
    this._hasRequired = false;
  }


  private loadLabels() {
    this._gridFields.getGridFieldTextLabelByPage(this._page, this._language)

      .subscribe((data: GridFieldTextSummary[]) => {
        this._gridFieldText = data;
        this._initForm();
      });
  }

  getLabel(objectCode: any) {
    if (this._gridFieldText) {
      if (this._gridFieldText.find(({ gridFieldDefinition }) => gridFieldDefinition?.objectCode === objectCode))
        var result = this._gridFieldText.find(({ gridFieldDefinition }) => gridFieldDefinition?.objectCode === objectCode);
      else
        result = null;

      return result ? result : null;
    }
  }

  getAuth() {
    // this._gridFields.getFileAuthorization(this._auth, this._currentUser.appRole.id)
    this._gridFields.getFieldsAuthorization(this._page, this._currentUser.appRole.id)

      .subscribe((x: GridFieldAuthorization[]) => {
        this._gridFieldAuth = x;
      });
  }

  getAuthByLabel(objectCode: any) {
    if (this._gridFieldAuth) {
      if (this._gridFieldAuth.find(({ gridFieldDefinition }) => gridFieldDefinition?.objectCode === objectCode))
        var result = this._gridFieldAuth.find(({ gridFieldDefinition }) => gridFieldDefinition?.objectCode === objectCode);
      else
        result = null;

      return result ? result : new GridFieldAuthorization();
    }
  }

  getLocationAuth() {
    this._gridFields.getFileAuthorization('mnuLocation', this._currentUser.appRole.id)

      .subscribe((x: GridFieldAuthorization) => {
        this._locationAuth = x;
      });
  }

  getPOAuth() {
    this._gridFields.getFileAuthorization('mnuStockPurchaseOrder', this._currentUser.appRole.id)

      .subscribe((x: GridFieldAuthorization) => {
        this._purchaseOrderAuth = x;
      });
  }

  getVendorAuth() {
    this._gridFields.getFileAuthorization('mnuSupplier', this._currentUser.appRole.id)

      .subscribe((x: GridFieldAuthorization) => {
        this._vendorAuth = x;
      });
  }

  _printReceiptReport() {
    var reportId = this.selectReceiptReport.value.id;
    this._layoutComponent.openDialogForm(ReportViewerPopupComponent, PageState.VIEW, { reportId: reportId, transactionId: this.transactionId });
    this._onClear();
  }

  locationValueChange(event: any) {
    if (event) {
      // this._loadItems();
      this.getStockItemDDPaging();
      if (this._form.get('vendor').value) {
        if (!this._form.get('purchaseOrder').value) {
          setTimeout(() => {
            if (this.kendoComboVendors != undefined) {
              this.kendoComboVendors.toggle();
              this.kendoComboVendors.focus();
            }
          });
        }

      } else {
        if (!this._form.get('purchaseOrder').value) {
          setTimeout(() => {
            if (this.kendoComboItems != undefined) {
              this.kendoComboItems.toggle();
              this.kendoComboItems.focus();
            }
          });
        }
      }
    }
  }

  getVendorStockNumber(item: any): string {
    if (!item) return '';
    const vendorId = this._form?.get('vendor')?.value?.id ?? this._selectedVendors?.[0]?.id;
    const vendors = item.stockItemVendors || item.stockItem?.stockItemVendors;
    if (vendors && vendors.length > 0) {
      if (vendorId && vendorId > 0) {
        const match = vendors.find((v: any) => v.vendorId === vendorId);
        if (match && (match.stockNumber || match.code)) return match.stockNumber || match.code;
      }
      const preferred = vendors.find((v: any) => v.isPreferred);
      if (preferred && (preferred.stockNumber || preferred.code)) return preferred.stockNumber || preferred.code;
      if (vendors[0]?.stockNumber || vendors[0]?.code) return vendors[0].stockNumber || vendors[0].code;
    }
    return item.vendorStockNumber || '';
  }

  vendorValueChange(event: any) {
    if (this._inventoryGridData && this._inventoryGridData.length > 0) {
      this._inventoryGridData.forEach(item => {
        item.vendorStockNumber = this.getVendorStockNumber(item);
      });
    }
    if (event) {
      setTimeout(() => {
        if (this.kendoComboItems.value === undefined) {
          this.kendoComboItems.toggle();
          this.kendoComboItems.focus();
        }
        // this._loadItems();
        this.getStockItemDDPaging();
      });
    }
  }

  poValueChange(event: any) {

    if (event) {
      if (!this._defaultLocationSettingEnabled) {
        setTimeout(() => {
          if (this.kendoComboLocations != undefined) {
            this.kendoComboLocations.toggle();
            this.kendoComboLocations.focus();
          }
        }, 500);
      } else {
        setTimeout(() => {
          if (this.kendoComboItems != undefined) {
            this.kendoComboItems.toggle();
            this.kendoComboItems.focus();
          }
          // this._loadItems();
        });
      }
    }
  }

  getDateEnabledOption() {
    this._TransactionDateEditting.getTransactionDateEditing('get-data').subscribe((x: any) => {
      if (x != undefined && x != null) {
        this._dateEnabled = x.transactionDateEditing;
        if (!this._dateEnabled) {
          this._form.get('date')?.disable();
        }
      }
    });
  }

  getBatchStockItems() {
    if (this._sharedService.batchStocks.stockItems) {
      this._sharedService.batchStocks.stockItems.forEach((element: any) => {
        this._inventoryCode.setValue('');
        this._itemType = this.getItemType(element.itemType.name);
        this._itemtypeId = element.itemType.id;

        if (this._itemType === 'standard' || !this._autoCodeGeneration.value) {
          if (this._itemType === 'standard') {
            this._inventoryCode.setValue(element.number);
            this._expirationDate.setValue(null);
          }
          if (this._itemtypeId === ItemsTypes.NonInventory) {
            this._inventoryCode.setValue(element.number);
          }

          let maxrowindex = Math.max(...this._inventoryGridData.map(o => o.rowindex), 0) + 1;
          let gridItem = this._inventoryGridData.find(r => r.itemNumber === element.number);
          let _Gquantity = this._itemType === 'serial'
            ? (this._quantity.value ? parseInt(this._quantity.value) : 0)
            : (this._quantity.value ? +this._quantity.value?.toFixed(this.digitNumber) : 0);

          if (!gridItem) {
            this._inventoryGridData.push({
              stockItemId: element.id,
              poid: null,
              itemNumber: element.number,
              description: element.description,
              quantity: _Gquantity,
              uom: element.receiveUnitOfMeasure.code,
              inventoryCode: this._inventoryCode.value,
              expirationDate: this._expirationDate.value,
              unitCost: element.costInfo?.cost ?? 0,
              itemType: this.getItemType(element.itemType.name),
              itemTypeId: element.itemType.id,
              minQuantity: element.minqty,
              maxQuantity: element.maxqty,
              stockPurchaseOrderId: 0,
              defaultLocation: element.defaultLocation?.code,
              defaultLocationId: element.defaultLocation?.id,
              uDField1: null,
              uDField2: null,
              uDField3: null,
              uDFieldDate1: null,
              uDFieldDate2: null,
              uDFieldDate3: null,
              rowindex: maxrowindex
            });
          }
        } else {
          // For batch/serial items with auto-generation
          if (this._itemType !== 'non-inventory' && this._autoCodeGeneration.value) {
            this.runGenerateBarcode(element);
          }
        }
      });

      this._sharedService.batchStocks.stockItems = [];
    }
  }

  _closeBarcodeForm() {
    if (this._printReceipt?.value) {
      if (this._settingsPrintReceipt?.receiveReportId > 0) {
        this._layoutComponent.openDialogForm(ReportViewerPopupComponent, PageState.VIEW, { reportId: this._settingsPrintReceipt.receiveReportId, transactionId: this.transactionId });
        this._onClear();
      }
      else {
        this._reportService.ReportsByCategoryAllSitesOnly('receiveHistory').subscribe(
          (x: any) => {
            this.receiveReports = x;
            this.showReports = true;
          });
      }
    } else {
      // this._onClear();

    }

    var closeComponent = {
      component: 'reportViewer',
      isClosed: true
    };
    this._previewWindow = false;
    this.ngOnDestroy();
    this._sharedService.closeDialog.emit(closeComponent);
    this._sharedService.model = {};
  }

  _checkLabel(event: any) {
    if (this._isOneLineItem === undefined || this._isOneLineItem === null) {
      this._isOneLineItem = true;
    }
  }

  _lineQtyChange(event: any) {
    let value = typeof event === 'string' ? event : (event?.target?.value || event?.target?.defaultValue);
    if (value === 'qty') {
      this._isOneLineItem = false;
    }
    else {
      this._isOneLineItem = true;
    }
    if (this._barcodemodel) {
      this._barcodemodel.isOneLineItem = this._isOneLineItem;
    }
  }

  _fileRemoveEventHandler(e: any) {
    let fileName = e.files[0].name;
    let delFile: FileSelectedStream = this._uploadedStream.find(f => f.name.toLowerCase() == fileName.toLowerCase());
    if (delFile != undefined) {
      let indx = this._uploadedStream.indexOf(delFile);
      this._uploadedStream.splice(indx, 1);
    }

    this._fileStream = null;
  }

  _fileSelectedChanges(ev: SelectEvent) {
    ev.files.forEach((file: FileInfo) => {
      if (file.rawFile) {
        this._file = file.rawFile;
        const reader = new FileReader();
        reader.readAsDataURL(file.rawFile);

        reader.onloadend = () => {
          this._fileStream = reader.result;
          if (this.checkFileExtention()) {
            let _selectedFileModel: FileSelectedStream = <FileSelectedStream>({
              stream: reader.result,
              size: file.rawFile.size,
              type: file.rawFile.type,
              name: file.rawFile.name,
              fileSource: fileSources.receiveTransaction,
              isNew: true
            });

            this._uploadedStream.push(_selectedFileModel);
          }
        };
      }
    });

    this._selectFile = this._fileSelectedChanges.length > 0;

    this.checkFileExtention();
  }

  private checkFileExtention(): boolean {
    let fileUploadedName = this._file.name;
    const allowedExtensions = ['doc', 'docx', 'csv', 'xls', 'xlsx', 'pdf'];
    const reg = /(?:\.([^.]+))?$/;
    const fileType = reg.exec(fileUploadedName)[1];

    if (allowedExtensions.indexOf(fileType) == -1) {
      this._layoutComponent.openPopup({
        title: 'Validation',
        message: 'Only DOC, DOCX, XLSX, PDF and CSV extensions are allowed.',
        withoutConfirm: true
      });

      setTimeout(() => {
        this.upload.clearFiles();
        this._file = null;
        this._fileStream = null;
      });

      return false;
    }
    else {
      return true;
    }
  }

  //#region  Vendors Select
  _selectVendorsHandler(): void {
    this._showVendorsGrid = true;
  }

  _onVendorRowSelectionChanges(e: any[]) {
    this._selectedVendors = [];
    e.forEach((item) => {
      this._selectedVendors.push(item);
    });
  }

  _closeVendorsWindow(): void {
    this._showVendorsGrid = false;
  }

  // _returnSelectedVendorsHandler(e: any[]): void {

  //     this._showVendorsGrid = false;

  //     this._selectedVendors.forEach((item: VendorSummary) => {
  //         this._form.controls.vendor.setValue(item);

  //     });
  //     this.vendorValueChange(e);
  // }

  _returnSelectedVendorsHandler(e: any): void {
    if (this._selectedVendors && this._selectedVendors.length > 0) {
      this._vendorsService.getVendor(this._selectedVendors[0])

        .subscribe((data: any) => {
          if (this._vendors.find(f => f.id == data.id) == undefined) {
            this._vendors.push(data);
          }

          this._form.patchValue({
            vendor: data
          });
          if (this._inventoryGridData && this._inventoryGridData.length > 0) {
            this._inventoryGridData.forEach(item => {
              item.vendorStockNumber = this.getVendorStockNumber(item);
            });
          }
        });

    }
    this._closeVendorsWindow();
  }
  _getVendors = (params?: any, model?: any): Observable<DataWithPagingMetadata<any>> => {
    if (model != null && model.filter != null) {
      return this._vendorsService.getVendors(params, model, this._form.controls['site'].value?.id);
    }
  }

  //#endregion

  //#region  Locations Select
  _selectLocationsHandler(): void {
    this._showLocationsGrid = true;
  }
  _onLocationRowSelectionChanges(e: any[]) {
    this._selectedLocations = [];
    e.forEach((item) => {
      this._selectedLocations.push(item);
    });
  }
  _closeLocationsWindow(): void {
    this._showLocationsGrid = false;
  }

  _returnSelectedLocationsHandler(e: any[]): void {

    // this._showLocationsGrid = false;
    // this._selectedLocations.forEach((item: LocationSummary) => {
    //     this._form.controls.location.setValue(item);
    // });
    //this.locationValueChange(e);
    if (this._selectedLocations && this._selectedLocations.length > 0) {
      this._locationsService.getLocation(this._selectedLocations[0])

        .subscribe((data: any) => {
          if (this._locations.find(f => f.id == data.id) == undefined) {
            this._locations.push(data);
          }

          this._form.patchValue({
            location: data
          });
        });

    }
    this._closeLocationsWindow();
  }
  _getLocations = (params?: any, model?: any): Observable<DataWithPagingMetadata<any>> => {
    let siteIdd: number | null;
    if (!this._currentUser.isEnterprise) {
      siteIdd = this._form.get('site').value?.id ?? this.siteId;
    }
    if (model != null && model.filter != null) {
      return this._locationsService.getLocations(params, model, siteIdd);
    }
  }
  //#endregion

  //#region  Search Doc
  _returnSelectedDocumentsHandler(e: any): void {
    this._selectedExistingFiles = [];
    this._selectedDocumentsKeys = [];
    if (this._currentUser.isEnterprise) {
      if (this._selectedAccounts.length) {
        this._showDocumentsGrid = false;
        let currentSelected = this._selectedDocumentsKeys.concat(this._selectedDocuments);
        this._selectedDocumentsKeys = currentSelected.filter((c, index) => {
          return currentSelected.indexOf(c) === index;
        });
      }
      else {
        this._layoutComponent.openPopup({
          title: 'Validation',
          message: 'Please choose the account with the site desired',
          withoutConfirm: true
        });
      }
    }
    else if (!this._currentUser.isEnterprise) {
      this._showDocumentsGrid = false;
      let currentSelected = this._selectedDocumentsKeys.concat(this._selectedDocuments);
      this._selectedDocumentsKeys = currentSelected.filter((c, index) => {
        return currentSelected.indexOf(c) === index;
      });

      this._selectedDocumentsKeys.forEach((v) => {
        let _selectedFileModel: FileSelectedStream = <FileSelectedStream>({
          stream: '',
          size: 0,
          type: '',
          name: '',
          fileSource: fileSources.receiveTransaction,
          isNew: false,
          existingFileId: v
        });

        this._selectedExistingFiles.push(_selectedFileModel);
        this._uploaderSelectMessage = 'Upload file..' + ` [ ${this._selectedExistingFiles.length} file(s) selected ]`;
      });
      this._addSalesOrderDDocument();
    }
  }

  _addSalesOrderDDocument() {
    this._stockItemFilesDocs = this._stockItemFilesDocs === null ? [] : this._stockItemFilesDocs;

    if (this._selectedObjectDocuments.length > 0) {
      this._selectedObjectDocuments.forEach((element: any) => {
        let stockItemFile: SalesOrderFile = new SalesOrderFile();
        stockItemFile.fileId = element.id;
        stockItemFile.fileName = element.name;
        stockItemFile.file = element;
        this._stockItemFilesDocs.push(stockItemFile);
      });
    }
  }
  _closeDocumentsWindow(): void {
    this._showDocumentsGrid = false;
  }
  _selectImagesHandler(e: any): void {
    if (this._currentUser.isEnterprise) {
      if (this._selectedAccounts.length) {
        this._showDocumentsGrid = true;
      } else {
        this._layoutComponent.openPopup({
          title: 'Validation',
          message: 'Please choose the account with the site desired',
          withoutConfirm: true
        });
      }
    }
    else if (!this._currentUser.isEnterprise) {
      this._showDocumentsGrid = true;
    }
  }

  _getAccountDocuments = (params?: any, model?: any): Observable<DataWithPagingMetadata<any>> => {
    return this._filesService.getAllDocuments(this._selectedAccounts, params, model);
  }

  _getSelectedDocuments = (params?: any, model?: any): Observable<DataWithPagingMetadata<any>> => {
    return this._filesService.getDocuments(params, model);
  }
  _onDocumentRowSelectionChanges(e: any[]) {
    this._selectedDocuments = [];
    e.forEach((item) => {
      this._selectedDocuments.push(+item);
    });
  }

  _onDocumentbjectRowSelectionChanges(e: any[]) {
    this._selectedObjectDocuments = [];
    this._selectedObjectDocuments = e;
  }
  //#endregion

  public remove(upload: UploadComponent, uid: string): void {
    upload.removeFilesByUid(uid);
  }

  public showButton(state: FileState): boolean {
    return state === FileState.Uploaded ? true : false;
  }
  //#region _handleItemsChange

  _handleItemsChange(value: any) {
    if (value != null) {
      // Check if this is a deleted PO item being re-added
      if (value._deletedPOItem) {
        this._reAddDeletedPOItem(value._deletedPOItem);
        this._selectedStockItem.setValue(null);
        return;
      }

      setTimeout(() => {
        this.quantityInput.focus();
      });
    }
  }

  _reAddDeletedPOItem(deletedItem: any) {
    // Remove from deleted items array
    this._deletedPOItems = this._deletedPOItems.filter(item => item.rowindex !== deletedItem.rowindex);

    // Generate new rowindex for the re-added item
    let maxrowindex = Math.max(...this._inventoryGridData.map(o => o.rowindex), 0) + 1;
    deletedItem.rowindex = maxrowindex;

    // Add back to grid
    this._inventoryGridData.push(deletedItem);

    // Reset the dropdown data if no more deleted items
    if (this._deletedPOItems.length === 0) {
      this.getStockItemDDPaging();
    }
  }

  scrollCombobox(event: any) {
    this.isOpened = true;
    if (this.clearTimeout) clearTimeout(this.clearTimeout);
    this.clearTimeout = setTimeout(() => {
      if (this.isOpened) {
        let domobject = document.querySelector('.k-list-content');
        if (domobject) {
          this._renderer2.listen(document.querySelector('.k-list-content'), 'scroll', (e: any) => {
            if (e.target.offsetHeight + e.target.scrollTop >= e.target.scrollHeight) {
              this.beginScroll = true;
              this.comboBoxpagingationParams.currentItem = (parseInt(this.comboBoxpagingationParams.currentItem) + this.comboBoxpagingationParams.totalbyPage).toString();
              this._loadItems();
            }
          });
        }
      }
    }, 2500);
  }

  onBlur(event: any) {
    if (event.value != null) {
      this.beginScroll = false;

      var resualt = this._items.find((a: any) => a.id == event.value.id);

      if (resualt !== undefined && resualt === null) {
        this._items = [];
        this._itemsFiltered = [];
        this.comboBoxpagingationParams.currentItem = '0';
        this._loadItems();
        this.kendoComboItems.close;
      }
    }
  }

  //#endregion


  //#region Stock Item With Paging Dropdown
  getStockItemDDPaging(): void {
    let siteIdd: number | null;

    if (!this._currentUser.isEnterprise) {
      siteIdd = this._form.get('site').value?.id ?? this.siteId;
    }
    if (!this._stockItemComboScroll) {
      this._stockItemsService.getstockItemListingWithPaging(siteIdd, this._stockItemComboBoxPagingParams).subscribe((data: any) => {
        this._allStockItemsCount = data.body.returnCount;
        this._itemsNew = [...data.body.data];
        this._itemsFilteredNew = [...data.body.data];
      });
    }
    else {
      this._stockItemsService.getstockItemListingWithPaging(siteIdd, this._stockItemComboBoxPagingParams).subscribe((data: any) => {
        this._itemsNew = this._itemsNew.concat(data.body.data);
        this._itemsFilteredNew = [...this._itemsNew];
      });
    }
  }
  _handleItemsFilterDropDownPaging(_filter: any) {
    this._stockItemDDSearch = _filter;
    this._itemFilter = _filter;
    this._stockItemComboScroll = false;
    setTimeout(() => {
      this._stockItemComboBoxPagingParams.search = _filter;
      this._stockItemComboBoxPagingParams.currentItem = '0';
      this._stockItemComboBoxPagingParams.page = 1;
      this.getStockItemDDPaging();
    }, 1000);
  }
  scrollComboboxNew(event: any) {
    this.isOpened = true;
    if (this.clearTimeout) clearTimeout(this.clearTimeout);
    this.clearTimeout = setTimeout(() => {
      if (this.isOpened) {
        let domobject = document.querySelector('.k-list-content');
        if (domobject) {
          this._renderer2.listen(document.querySelector('.k-list-content'), 'scroll', (e: any) => {
            if (this._itemsNew.length < this._allStockItemsCount) {
              if (e.target.offsetHeight + e.target.scrollTop >= e.target.scrollHeight - 5) {
                this._stockItemComboScroll = true;
                this._stockItemComboBoxPagingParams.currentItem = (parseInt(this._stockItemComboBoxPagingParams.currentItem) + this._stockItemComboBoxPagingParams.totalbyPage).toString();
                this._stockItemComboBoxPagingParams.page++;
                this.getStockItemDDPaging();
              }
            }
          });
        }
      }
    }, 500);
  }

  _onStockItemDropdownOpened() {
    // When PO is selected and there are deleted items, show only deleted items in dropdown
    if (this.porderid > 0 && this._poPreference == 'full' && this._deletedPOItems.length > 0) {
      this._itemsFilteredNew = this._deletedPOItems.map(item => ({
        id: item.stockItemId,
        number: item.itemNumber,
        description: item.description,
        itemType: { id: item.itemTypeId, name: item.itemType },
        receiveUnitOfMeasure: { code: item.uom },
        costInfo: { cost: item.unitCost },
        defaultLocation: item.defaultLocationId ? { id: item.defaultLocationId, code: item.defaultLocation } : null,
        minqty: item.minQuantity,
        maxqty: item.maxQuantity,
        // Keep reference to original deleted item for re-adding
        _deletedPOItem: item
      }));
    }
  }
  //#endregion

  ngOnDestroy() {
    this._receiveTransactionsService.FromInventory = [];
  };
}
